import * as Yup from "yup";
import React, { Fragment, useEffect } from "react";
import moment from "moment";
import { useFormikContext } from "formik";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  AccountHolderType,
  AreaClassification,
  CadastreType,
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  CaseSubTypes,
  DeclarationType,
  PersonSex,
  UserRoleEnum,
  PersonType,
  TipoBollettaRecapito,
  TipologiaUsoFornitura,
  TipologiaIntestatario,
} from "../../../helpers/enums";
import {
  TranslatedText,
  SwitchUser,
  getValidationRule,
  getStandardAddressFormat,
  getComuniServiti,
  getCorrectLink,
  removeDeletedLayoutFields,
  removeRequiredStep, getValidationObject,
  getCities
} from "../../../helpers/helpers";
import { CaseFormField } from "../CaseGenerator";
import getMenuConfig from "../../../helpers/menuConfig";
import DigitalizzazioneDocument from "../custom-steps/custom-digitalizzazione-step/DigitalizzazioneDocument";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";


let sign = false;
const {
  pdfLinks: { casesInfoAllacciamento },
} = getMenuConfig();
const InfoLabel = ({ label = "Test label" }) => {
  return (
    <div className="info-label">
      <span className="gc-icon-functional-attention-2-col">
        <span className="path1" />
        <span className="path2" />
      </span>
      <p>{label}</p>
    </div>
  );
};

const PlainLabel = ({ label = "Test label" }) => {
  return (
    <div className="plain-label">
      <p>{label}</p>
    </div>
  );
};
const SimpleText = ({ text = "Test text" }) => {
  return (
    <div className="simple-text">
      <span>{text}</span>
    </div>
  );
};
const FatturazioneElettronica = (props) => {
  const { layout, fields } = props;
  const { fields: layoutFields } = layout;
  const { setFieldValue } = useFormikContext();
  const user = useSelector((state) => state.auth);

  // contains true or false if a user was found or not
  const { userFetched } = user;

  // returns actual profile or the impersenation profile field from the user object
  const userProfile = SwitchUser(user);

  // get the user role of type UserRoleEnum
  const role = userProfile.role;
  useEffect(() => {
    setFieldValue("userRole", role);
  }, [role, setFieldValue]);

  const isConditionMet = (conditionProps) => {
    if (!conditionProps) {
      return true;
    }
    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }

    let allowed = false;
    conditions.forEach((condition) => {
      if (userFetched && role === condition.is) {
        allowed = true;
      }
    });
    return allowed;
  };

  return (
    <Fragment key={layout.title}>
      {layout.title && <h2 className={"case-step-title"}>{layout.title}</h2>}
      {layout.description && (
        <p className={"case-step-description"}>{layout.description}</p>
      )}
      <Row>
        {layoutFields &&
          layoutFields.map((item, index) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            const fieldProps = fields[item.fieldName];
            const conditionMet = isConditionMet(conditionProps);
            return (
              conditionMet && (
                <Col {...gridProps} key={index}>
                  {!item.fieldName && (
                    <h3 className="form-section-title">{item.text}</h3>
                  )}
                  {item.fieldName && <CaseFormField {...fieldProps} />}
                </Col>
              )
            );
          })}
        {layout.content && (
          <div className="col-12">
            <div className={"content"}>{layout.content}</div>
          </div>
        )}
      </Row>
    </Fragment>
  );
};
const startEventDataLayer = () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Allaccio, "step": "avvio" }) };
let model = {
  formId: CaseForms.Allaccio,
  formField: {
    // step 1.1
    comune: {
      name: "comune",
      label: <TranslatedText i18nKey="cases.allacciamento.comune.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.comune.placeholder" />
      ),
      message: true,
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "suggestions",
      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.comune).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            via.city = selected.comune;
            setFieldValue(via.name, "");
            setFieldValue(numeroCivico.name, "");
            // step 4.1
            setFieldValue("datiImmobile_comune", selected.comune);
            setFieldValue("datiImmobile_cap", selected.cap);
            setFieldValue("datiImmobile_provincia", selected.provincia);
            // step 4.3
            setFieldValue("datiCatastali_comune", selected.comune);
            setFieldValue("datiCatastali_provincia", selected.provincia);
            setFieldValue("datiCatastali_comuneCatastale", selected.comune);
            setFieldValue(
              "datiCatastali_provinciaComuneCatastale",
              selected.provincia
            );
          }
        }
      },
      onBlur: (value, data, setValue, isSentDataLayer, setIsSentDataLayer) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
        if (!isSentDataLayer) {
          startEventDataLayer();
          setIsSentDataLayer(true);
        }
      },
    },
    via: {
      name: "via",
      label: <TranslatedText i18nKey="cases.allacciamento.via.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.via.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.via.required" />
      ),
      type: "egon-address",
      suggestionType: "address",
      city: "",
      step : "1",
      onError: (value, setFieldValue) => {
        setFieldValue(via.name, value);
        numeroCivico.readonly = false;
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(via.name, value);
        setFieldValue(numeroCivico.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(via.name, isStreetValid ? components.via : "");
        setFieldValue(numeroCivico.name, components.civico);
        egonCodeResponse.tipo_Indirizzo="puf";
        via.egonCodePuf = {...egonCodeResponse};
        egonCodeResponse.tipo_Indirizzo = "proprietario";
        via.egonCodeProprietario={...egonCodeResponse};
      }
    },
    numeroCivico: {
      name: "numeroCivico",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.numero_civico.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.numero_civico.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.numero_civico.required" />
      ),
      type: "input"
    },
    tipologia: {
      name: "tipologia",
      label: <TranslatedText i18nKey="cases.allacciamento.tipologia.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.tipologia.placeholder" />
      ),
      textSummaryWithKeyPrefix: 'cases.enums.CaseSubTypes.',
      requiredErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "select",
      options: [
        {
          label: <TranslatedText i18nKey={"cases.enums.CaseSubTypes.WATER"} />,
          value: CaseSubTypes.WATER,
        },
        {
          label: (
            <TranslatedText i18nKey={"cases.enums.CaseSubTypes.WATER_EXT"} />
          ),
          value: CaseSubTypes.WATER_EXT,
        },
      ],
    },

    // step 1.2
    tipoIntestatario: {
      name: "tipoIntestatario",
      type: "switch-radio",
      summaryView: false,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      options: [
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.NATURAL" />,
          value: PersonType.NATURAL,
          grid: { xs: 12, md: 3 },
        },
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.LEGAL" />,
          value: PersonType.LEGAL,
          grid: { xs: 12, md: 3 },
        },
      ],
      onSelected: (selected, values, profile, setFieldValue) => {
        setFieldValue(signValue.name, sign);
        if (profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
          let piva = "";
          let fiscalCode = "";
          if (profile.fiscalCode !== "") {
            if (isNaN(Number(profile.fiscalCode))) {
              fiscalCode = profile.fiscalCode;
            } else {
              piva = profile.fiscalCode;
            }
          }
          if (selected === PersonType.NATURAL) {
            values[fisicaNome.name] === "" &&
              setFieldValue(fisicaNome.name, profile.name || "");
            values[fisicaCognome.name] === "" &&
              setFieldValue(fisicaCognome.name, profile.surname || "");
            values[fisicaCodiceFiscale.name] === "" &&
              setFieldValue(fisicaCodiceFiscale.name, fiscalCode || "");
          }
          if (selected === PersonType.LEGAL) {
            values[businessName.name] === "" &&
              setFieldValue(businessName.name, profile.businessName || "");
            values[giuridicaCodiceFiscale.name] === "" &&
              setFieldValue(giuridicaCodiceFiscale.name, fiscalCode || "");
            values[giuridicaPartitaIVA.name] === "" &&
              setFieldValue(giuridicaPartitaIVA.name, piva || "");
            values[giuridicaPartitaIVA2.name] === "" &&
              setFieldValue(giuridicaPartitaIVA2.name, piva || "");
            values[giuridicaNome.name] === "" &&
              setFieldValue(giuridicaNome.name, profile.name || "");
            values[giuridicaCognome.name] === "" &&
              setFieldValue(giuridicaCognome.name, profile.surname || "");
            values[giuridicaSedeLegaleComune.name] === "" &&
              setFieldValue(
                giuridicaSedeLegaleComune.name,
                profile.legalAddress_city || ""
              );
            values[giuridicaProvincia.name] === "" &&
              setFieldValue(
                giuridicaProvincia.name,
                profile.legalAddress_province || ""
              );
            values[giuridicaCAP.name] === "" &&
              setFieldValue(
                giuridicaCAP.name,
                profile.legalAddress_postalCode || ""
              );
            values[giuridicaIndirizzo.name] === "" &&
              setFieldValue(
                giuridicaIndirizzo.name,
                profile.legalAddress_street
                  ? `${profile.legalAddress_street}, ${profile.legalAddress_streetNumber}`
                  : ""
              );
          }
          values[bollettaEsistenteCellulare.name] === "" &&
            setFieldValue(
              bollettaEsistenteCellulare.name,
              profile.mobilePhoneNumber || ""
            );
          values[bollettaEsistenteEmail.name] === "" &&
            setFieldValue(bollettaEsistenteEmail.name, profile.email || "");
        }
      },
    },
    fisicaNome: {
      name: "fisicaNome",
      label: <TranslatedText i18nKey="cases.allacciamento.fisica_nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.fisica_nome.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "input",
    },
    fisicaCognome: {
      name: "fisicaCognome",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.required" />
      ),
      type: "input",
    },
    fisicaCodiceFiscale: {
      name: "fisicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCodiceFiscale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCodiceFiscale.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.errors.codicefiscale_invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "input",
      uppercase: true,
    },
    fisicaNatoA: {
      name: "fisicaNatoA",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaNatoA.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaNatoA.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "suggestions",
      message: true,
      getItems: (setData) => {
        return getCities()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      getSuggestionValue: (suggestion) => {
        return suggestion.city
      },
      renderSuggestion: (suggestion) => {
        return (
          <div>{suggestion.city}</div>
        );
      },
      filter: async (value, data, setData) => {
        const newData = await getCities(value);
        if (setData)
          setData(newData);
        return newData && newData.filter((item) => {
          return (
            String(item.city)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.city).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            setFieldValue(fisicaNatoA.name, selected.city);
          }
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.city).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.city) : setValue("");
      },
    },
    fisicaDataNascita: {
      name: "fisicaDataNascita",
      label: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.dataNascita.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaDataNascita.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "date",
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    fisicaSesso: {
      name: "fisicaSesso",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaSesso.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "radio",
      options: [
        { label: "M", value: PersonSex.M, grid: { xs: 4 } },
        { label: "F", value: PersonSex.F, grid: { xs: 4 } },
      ],
    },
    fisicaIndirizzo: {
      name: "fisicaIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaIndirizzoResidenza.required.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.fisica_indirizzo.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(fisicaIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(fisicaIndirizzo.name, value);
        setFieldValue(fisicaComuneResidenza.name, "");
        setFieldValue(fisicaProvincia.name, "");
        setFieldValue(fisicaCAP.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(fisicaIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(fisicaComuneResidenza.name, components.comune);
        setFieldValue(fisicaProvincia.name, components.provincia);
        setFieldValue(fisicaCAP.name, components.cap);
        egonCodeResponse.tipo_Indirizzo="residenza";
        fisicaIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    fisicaComuneResidenza: {
      name: "fisicaComuneResidenza",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaComuneResidenza.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaComuneResidenza.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "input",
    },
    fisicaProvincia: {
      name: "fisicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaProvincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaProvincia.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    fisicaCAP: {
      name: "fisicaCAP",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCAP.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCAP.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cap.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input"
    },
    // Giuridico
    businessName: {
      name: "businessName",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.ragioneSociale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaRagioneSociale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
    },
    giuridicaCodiceFiscale: {
      name: "giuridicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaCodiceFiscale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaCodiceFiscale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.errors.codicefiscale_invalid" />
      ),
      uppercase: true,
      type: "input",
    },
    giuridicaPartitaIVA: {
      name: "giuridicaPartitaIVA",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVA.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVA.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaPartitaIVA2: {
      name: "giuridicaPartitaIVA2",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVA.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVA.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaPartitaIVAGrupoCheckbox: {
      name: "giuridicaPartitaIVAGrupoCheckbox",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step1.2.giuridicaPartitaIVAGrupoCheckbox.label" />
      ),
      type: "checkbox",
    },
    giuridicaPartitaIVAGrupo: {
      name: "giuridicaPartitaIVAGrupo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVAGrupo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaNome: {
      name: "giuridicaNome",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleName.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaCognome: {
      name: "giuridicaCognome",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleSurname.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaIndirizzo: {
      name: "giuridicaIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.sede_legale_indirizzo.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(giuridicaIndirizzo.name, value);
        giuridicaSedeLegaleComune.readonly = false;
        giuridicaProvincia.readonly = false;
        giuridicaCAP.readonly = false;
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(giuridicaIndirizzo.name, value);
        setFieldValue(giuridicaSedeLegaleComune.name, "");
        setFieldValue(giuridicaProvincia.name, "");
        setFieldValue(giuridicaCAP.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(giuridicaIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        if (components.comune) {
          setFieldValue(giuridicaSedeLegaleComune.name, components.comune);
          giuridicaSedeLegaleComune.readonly = true;
        } else {
          setFieldValue(giuridicaSedeLegaleComune.name, "");
          giuridicaSedeLegaleComune.readonly = false;
        }

        if (components.provincia) {
          setFieldValue(giuridicaProvincia.name, components.provincia);
          giuridicaProvincia.readonly = true;
        } else {
          setFieldValue(giuridicaProvincia.name, "");
          giuridicaProvincia.readonly = false;
        }

        if (components.cap) {
          setFieldValue(giuridicaCAP.name, components.cap);
          giuridicaCAP.readonly = true;
        } else {
          setFieldValue(giuridicaCAP.name, "");
          giuridicaCAP.readonly = false;
        }
        egonCodeResponse.tipo_Indirizzo="residenza";
        giuridicaIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    giuridicaSedeLegaleComune: {
      name: "giuridicaSedeLegaleComune",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaSedeLegaleComune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaRappresentanteLegale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    giuridicaProvincia: {
      name: "giuridicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaProvincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaProvincia.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    giuridicaCAP: {
      name: "giuridicaCAP",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCAP.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaCAP.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cap.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    // step 2.1
    paCode: {
      name: "paCode",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.destinario_pa.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    userRole: {
      name: "userRole",
      type: "input",
    },
    pec: {
      name: "pec",
      label: <TranslatedText i18nKey="cases.voltura.fields.email_pec.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.email_pec.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />
      ),
      type: "input",
    },
    cigCode: {
      name: "cigCode",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.person_type.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    cupCode: {
      name: "cupCode",
      label: <TranslatedText i18nKey="cases.voltura.fields.cup_code.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    splitPaymentCat: {
      name: "splitPaymentCat",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.split_payment_cat.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    sdiCode: {
      name: "sdiCode",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.destinario_sdi.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    // step 3.1
    signValue: {
      name: 'signValue',
      label: <TranslatedText i18nKey="cases.request_info.fields.sign.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input'
    },
    bollettaRecapitoTipo: {
      name: "bollettaRecapitoTipo",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoTipo.label" />
          ),
          value: TipoBollettaRecapito.PRE_ESISTENTE,
          grid: { xs: 12 },
        },
      ],
    },
    bollettaRecapitoNuovoIndirizzo: {
      name: "bollettaRecapitoTipo",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      onChange: (selected, values, setFieldValue) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, "");
        setFieldValue(bollettaEsistenteComune.name, "");
        setFieldValue(bollettaEsistenteProvincia.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
      },
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoNuovoIndirizzo.label" />
          ),
          value: TipoBollettaRecapito.NUOVO,
          grid: { xs: 12 },
        },
      ],
    },
    bollettaPuntoDiFurnitura: {
      name: "bollettaPuntoDiFurnitura",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "button",
      title: <TranslatedText i18nKey="common.select" />,
      // className: 'selected',
      summaryView: false,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaDatiIntestatario.name)
          .classList.remove("selected");
        const egonOrder = bollettaEsistenteIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        inputs[0].value = `${values.via}, ${values.numeroCivico}`;
        let egonCodeResponse = {...via.egonCodePuf};
        if(Object.keys(egonCodeResponse).length !== 0){
          egonCodeResponse.tipo_Indirizzo ="recapito";
          bollettaEsistenteIndirizzo.egonCodeResponse = egonCodeResponse;
        }
        setFieldValue(
          bollettaEsistenteIndirizzo.name,
          `${values.via}, ${values.numeroCivico}`
        );
        setFieldValue(bollettaEsistenteComune.name, values.comune);
        setFieldValue(bollettaEsistenteProvincia.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
      },
    },
    bollettaDatiIntestatario: {
      name: "bollettaDatiIntestatario",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "button",
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaPuntoDiFurnitura.name)
          .classList.remove("selected");
        const egonOrder = bollettaEsistenteIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        const value = values.tipoIntestatario === PersonType.NATURAL ? values.fisicaIndirizzo : values.giuridicaIndirizzo;
        inputs[0].value = value;
        let egonCodeResponse =PersonType.NATURAL ? {...fisicaIndirizzo.egonCodeResponse} : {...giuridicaIndirizzo.egonCodeResponse};
        if(Object.keys(egonCodeResponse).length !== 0){
          egonCodeResponse.tipo_Indirizzo ="recapito";
          bollettaEsistenteIndirizzo.egonCodeResponse = egonCodeResponse; 
        }
        setFieldValue(
          bollettaEsistenteIndirizzo.name,
          value
        );
        setFieldValue(
          bollettaEsistenteComune.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaComuneResidenza
            : values.giuridicaSedeLegaleComune
        );
        setFieldValue(
          bollettaEsistenteProvincia.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaProvincia
            : values.giuridicaProvincia
        );
        setFieldValue(
          bollettaEsistenteCap.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaCAP
            : values.giuridicaCAP
        );
      },
    },
    bollettaEsistenteIndirizzo: {
      name: "bollettaEsistenteIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      type: "egon-address",
      step : "3",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, value);
        setFieldValue(bollettaEsistenteComune.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
        setFieldValue(bollettaEsistenteProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaEsistenteIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaEsistenteComune.name, components.comune || "");
        setFieldValue(bollettaEsistenteCap.name, components.cap || "");
        setFieldValue(
          bollettaEsistenteProvincia.name,
          components.provincia || ""
        );
        egonCodeResponse.tipo_Indirizzo="recapito";
        bollettaEsistenteIndirizzo.egonCodeResponse=egonCodeResponse;
      },
    },
    bollettaEsistenteComune: {
      name: "bollettaEsistenteComune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder" />
      ),
      type: "input",
    },
    bollettaEsistenteCap: {
      name: "bollettaEsistenteCap",
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaEsistenteProvincia: {
      name: "bollettaEsistenteProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaNomePresso: {
      name: "bollettaNomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCognomePresso: {
      name: "bollettaCognomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.cognome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaEsistenteCellulare: {
      name: "bollettaEsistenteCellulare",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.required" />
      ),
      type: "input",
    },
    bollettaEsistenteFisso: {
      name: "bollettaEsistenteFisso",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    bollettaEsistenteEmail: {
      name: "bollettaEsistenteEmail",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.required" />
      ),
      type: "input",
    },
    bollettaConfirmEmail: {
      name: "bollettaConfirmEmail",
      label: (
        <TranslatedText i18nKey="cases.digitalization.confirm" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaConfirmNuovoEmail: {
      name: "bollettaConfirmNuovoEmail",
      label: (
        <TranslatedText i18nKey="cases.digitalization.confirm" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaEsistentePec: {
      name: "bollettaEsistentePec",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />
      ),
      type: "input",
    },
    // old Address
    bollettaNuovoIndirizzo: {
      name: "bollettaNuovoIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaNuovoIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaNuovoIndirizzo.name, value);
        setFieldValue(bollettaNuovoComune.name, "");
        setFieldValue(bollettaNuovoCap.name, "");
        setFieldValue(bollettaNuovoProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaNuovoIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaNuovoComune.name, components.comune || "");
        setFieldValue(bollettaNuovoCap.name, components.cap || "");
        setFieldValue(bollettaNuovoProvincia.name, components.provincia || "");
        egonCodeResponse.tipo_Indirizzo="recapito";
        bollettaNuovoIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "3",
    },
    bollettaNuovoComune: {
      name: "bollettaNuovoComune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder" />
      ),
      type: "input",
    },
    bollettaNuovoCap: {
      name: "bollettaNuovoCap",
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cap.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaNuovoProvincia: {
      name: "bollettaNuovoProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaNuovoPresso: {
      name: "bollettaNuovoPresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaNuovoCellulare: {
      name: "bollettaNuovoCellulare",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.required" />
      ),
      type: "input",
    },
    bollettaNuovoFisso: {
      name: "bollettaNuovoFisso",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    bollettaNuovoEmail: {
      name: "bollettaNuovoEmail",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bollettaNuovoPec: {
      name: "bollettaNuovoPec",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      type: "input",
    },

    // step 4.1
    datiImmobile_cognomeNomeRecapito: {
      name: "datiImmobile_cognomeNomeRecapito",
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cognomeNomeRecapito.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cognomeNomeRecapito.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cognomeNomeRecapito.required" />
      ),
    },
    datiImmobile_codiceFiscale: {
      name: "datiImmobile_codiceFiscale",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_codiceFiscale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_codiceFiscale.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_codiceFiscale.required" />
      ),
      uppercase: true,
    },
    datiImmobile_partitaIva: {
      name: "datiImmobile_partitaIva",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_partitaIva.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_partitaIva.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_partitaIva.required" />
      ),
    },
    datiImmobile_indirizzoCivico: {
      name: "datiImmobile_indirizzoCivico",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_indirizzoCivico.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_indirizzoCivico.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_indirizzoCivico.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiImmobile_comune: {
      name: "datiImmobile_comune",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_comune.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_comune.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiImmobile_cap: {
      name: "datiImmobile_cap",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cap.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cap.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cap.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiImmobile_provincia: {
      name: "datiImmobile_provincia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_provincia.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_provincia.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiImmobile_cellulare: {
      name: "datiImmobile_cellulare",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cellulare.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cellulare.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_cellulare.required" />
      ),
    },
    datiImmobile_fisso: {
      name: "datiImmobile_fisso",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_fisso.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_fisso.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_fisso.required" />
      ),
    },
    datiImmobile_email: {
      name: "datiImmobile_email",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_email.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_email.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_email.required" />
      ),
    },

    // step 4.2
    inQualitaDi: {
      name: "inQualitaDi",
      label: "",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.in_qualita_di" />
      ),
      onChange: (selected, values, setFieldValue) => {
        if (selected !== AccountHolderType.OWNER) {
          setFieldValue(ilSottoscrittoNome.name, "");
          setFieldValue(ilSottoscrittoCognome.name, "");

          setFieldValue(dichiaro_diEssereIntestatario.name, false);
          setFieldValue(dichiaro_diEssereIntestatario_numero.name, "");
          setFieldValue(dichiaro_diEssereIntestatario_data.name, "");

          setFieldValue(dichiaro_rilasciatoPermesso.name, false);
          setFieldValue(dichiaro_rilasciatoPermesso_numero.name, "");
          setFieldValue(dichiaro_rilasciatoPermesso_data.name, "");

          setFieldValue(dichiaro_presentataDia.name, false);
          setFieldValue(dichiaro_presentataDia_numero.name, "");
          setFieldValue(dichiaro_presentataDia_data.name, "");

          setFieldValue(dichiaro_presentataScia.name, false);
          setFieldValue(dichiaro_presentataScia_numero.name, "");
          setFieldValue(dichiaro_presentataScia_data.name, "");

          setFieldValue(dichiaro_dataCostruzioneIdonea.name, false);
          setFieldValue(dichiaro_dataCostruzioneIdonea_data.name, "");

          setFieldValue(dichiaro_presaEsistente.name, false);
          setFieldValue(dichiaro_presaEsistente_numero.name, "");
          setFieldValue(dichiaro_presaEsistente_data.name, "");

          setFieldValue(dichiaro_altro.name, false);
          setFieldValue(dichiaro_altro_testo.name, "");
        }
        if (selected !== AccountHolderType.OTHER) {
          setFieldValue(inQualitaDi_altro.name, "");
        }
        if (selected === AccountHolderType.OWNER) {
          setFieldValue(dichiaro_diEssereIntestatario.name, true);
        }
      },
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.OWNER" />
          ),
          value: AccountHolderType.OWNER,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.TENANT" />
          ),
          value: AccountHolderType.TENANT,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.CONDOMINIUM_ADMIN" />
          ),
          value: AccountHolderType.CONDOMINIUM_ADMIN,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.USUFRUCTUARY" />
          ),
          value: AccountHolderType.USUFRUCTUARY,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.LEGAL_REPRESENTATIVE" />
          ),
          value: AccountHolderType.LEGAL_REPRESENTATIVE,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.OTHER" />
          ),
          value: AccountHolderType.OTHER,
          grid: { md: 4 },
        },
      ],
    },
    inQualitaDi_altro: {
      name: "inQualitaDi_altro",
      type: "input",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.inQualitaDi_altro.placeholder" />
      ),
    },
    ilSottoscrittoNome: {
      name: "ilSottoscrittoNome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.error_message" />
      ),
      type: "input",
    },
    ilSottoscrittoCognome: {
      name: "ilSottoscrittoCognome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.error_message" />
      ),
      type: "input",
    },
    dichiaro_diEssereIntestatario: {
      name: "dichiaro_diEssereIntestatario",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_diEssereIntestatario.label" />
      ),
      type: "checkbox",
    },
    dichiaro_diEssereIntestatario_numero: {
      name: "dichiaro_diEssereIntestatario_numero",
      type: "input",
      placeholder: (<TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    dichiaro_diEssereIntestatario_data: {
      name: "dichiaro_diEssereIntestatario_data",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_possessoImmobile: {
      name: "dichiaro_possessoImmobile",
      label: <TranslatedText i18nKey="cases.data_possesso_immobile.step4_1" />,
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_possessoImmobile_data.disabled = true));
        } else {
          setFieldValue((dichiaro_possessoImmobile_data.disabled = false));
        }
      },
    },
    dichiaro_possessoImmobile_data: {
      name: "dichiaro_possessoImmobile_data",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      disabled: true,
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_rilasciatoPermesso: {
      name: "dichiaro_rilasciatoPermesso",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_rilasciatoPermesso.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_rilasciatoPermesso_numero.disabled = true));
          setFieldValue((dichiaro_rilasciatoPermesso_data.disabled = true));
        } else {
          setFieldValue((dichiaro_rilasciatoPermesso_numero.disabled = false));
          setFieldValue((dichiaro_rilasciatoPermesso_data.disabled = false));
        }
      },
    },
    dichiaro_rilasciatoPermesso_numero: {
      name: "dichiaro_rilasciatoPermesso_numero",
      type: "input",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    dichiaro_rilasciatoPermesso_data: {
      name: "dichiaro_rilasciatoPermesso_data",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_presentataDia: {
      name: "dichiaro_presentataDia",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_presentataDia.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_presentataDia_numero.disabled = true));
          setFieldValue((dichiaro_presentataDia_data.disabled = true));
        } else {
          setFieldValue((dichiaro_presentataDia_numero.disabled = false));
          setFieldValue((dichiaro_presentataDia_data.disabled = false));
        }
      },
    },
    dichiaro_presentataDia_numero: {
      name: "dichiaro_presentataDia_numero",
      type: "input",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    dichiaro_presentataDia_data: {
      name: "dichiaro_presentataDia_data",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_presentataScia: {
      name: "dichiaro_presentataScia",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_presentataScia.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_presentataScia_numero.disabled = true));
          setFieldValue((dichiaro_presentataScia_data.disabled = true));
        } else {
          setFieldValue((dichiaro_presentataScia_numero.disabled = false));
          setFieldValue((dichiaro_presentataScia_data.disabled = false));
        }
      },
    },
    dichiaro_presentataScia_numero: {
      name: "dichiaro_presentataScia_numero",
      type: "input",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    dichiaro_presentataScia_data: {
      name: "dichiaro_presentataScia_data",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      disabled: true,
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_dataCostruzioneIdonea: {
      name: "dichiaro_dataCostruzioneIdonea",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_dataCostruzioneIdonea.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_dataCostruzioneIdonea_data.disabled = true));
        } else {
          setFieldValue((dichiaro_dataCostruzioneIdonea_data.disabled = false));
        }
      },
    },
    dichiaro_dataCostruzioneIdonea_data: {
      name: "dichiaro_dataCostruzioneIdonea_data",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      disabled: true,
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_presaEsistente: {
      name: "dichiaro_presaEsistente",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_presaEsistente.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_presaEsistente_numero.disabled = true));
          setFieldValue((dichiaro_presaEsistente_data.disabled = true));
        } else {
          setFieldValue((dichiaro_presaEsistente_numero.disabled = false));
          setFieldValue((dichiaro_presaEsistente_data.disabled = false));
        }
      },
    },
    dichiaro_presaEsistente_numero: {
      name: "dichiaro_presaEsistente_numero",
      type: "input",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    dichiaro_presaEsistente_data: {
      name: "dichiaro_presaEsistente_data",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.datepicker.placeholder" />
      ),
      type: "date",
      disabled: true,
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    dichiaro_altro: {
      name: "dichiaro_altro",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_altro.name" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue((dichiaro_altro_testo.disabled = true));
        } else {
          setFieldValue((dichiaro_altro_testo.disabled = false));
        }
      },
    },
    dichiaro_altro_testo: {
      name: "dichiaro_altro_testo",
      type: "input",
      disabled: true,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.other.placeholder" />
      ),
    },

    // step 4.3

    datiCatastali_tipologia: {
      name: "datiCatastali_tipologia",
      label: "",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.enums.CadastreType.MANUFACTURED" />
          ),
          value: CadastreType.MANUFACTURED,
          grid: { sm: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.CadastreType.PROPERTY_NOT_STACKED" />
          ),
          value: CadastreType.PROPERTY_NOT_STACKED,
          grid: { sm: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.CadastreType.AGRICULTURAL_LAND" />
          ),
          value: CadastreType.AGRICULTURAL_LAND,
          grid: { sm: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.CadastreType.NON_STACKABLE_PROPERTY" />
          ),
          value: CadastreType.NON_STACKABLE_PROPERTY,
          grid: { sm: 12, md: 3 },
        },
      ],
    },
    datiCatastali_comune: {
      name: "datiCatastali_comune",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_comune.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    datiCatastali_provincia: {
      name: "datiCatastali_provincia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_provincia.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    datiCatastali_comuneCatastale: {
      name: "datiCatastali_comuneCatastale",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_comuneCatastale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_comuneCatastale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      message: true,

      type: "suggestions",
      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.comune).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            setFieldValue(
              datiCatastali_provinciaComuneCatastale.name,
              selected.provincia
            );
          }
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
      },
    },
    datiCatastali_provinciaComuneCatastale: {
      name: "datiCatastali_provinciaComuneCatastale",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_provinciaComuneCatastale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_provinciaComuneCatastale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      readonly: true,
    },
    datiCatastali_indirizzo: {
      name: "datiCatastali_indirizzo",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_indirizzo.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      readonly: true,
    },
    datiCatastali_civico: {
      name: "datiCatastali_civico",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_civico.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_civico.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      readonly: true,
    },
    datiCatastali_edificio: {
      name: "datiCatastali_edificio",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_edificio.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_edificio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_scale: {
      name: "datiCatastali_scale",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_scale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_scale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_piano: {
      name: "datiCatastali_piano",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_piano.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_piano.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_appartamento: {
      name: "datiCatastali_appartamento",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_appartamento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_appartamento.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_codiceComuneCatastale: {
      name: "datiCatastali_codiceComuneCatastale",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_codiceComuneCatastale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_codiceComuneCatastale.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_sezioneUrbana: {
      name: "datiCatastali_sezioneUrbana",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_sezioneUrbana.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_sezioneUrbana.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_foglio: {
      name: "datiCatastali_foglio",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_foglio.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_foglio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_particella: {
      name: "datiCatastali_particella",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_particella.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_particella.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },
    datiCatastali_subalterno: {
      name: "datiCatastali_subalterno",
      type: "input",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_subalterno.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.datiCatastali_subalterno.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
    },

    // step 5.1

    tipologiaUso: {
      name: "tipologiaUso",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domenistico.label" />
          ),
          value: TipologiaUsoFornitura.DOMESTICO,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domenistico.label" />
          ),
          value: TipologiaUsoFornitura.NON_DOMESTICO,
          grid: { md: 4 },
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected !== TipologiaUsoFornitura.NON_DOMESTICO) {
          setFieldValue(tipologiaUsoNonDomestica.name, 'AreaClassification.INDUSTRIAL_USE');
        }
      },
    },
    tipologiaUsoDomestica: {
      name: "tipologiaUsoDomestica",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.domestico.label" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.domestico.residente.label" />
          ),
          value: AreaClassification.RESIDENT_DOMESTIC_USE,
          grid: { xs: 12, md: 6 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.domestico.non_residente.label" />
          ),
          value: AreaClassification.NOT_RESIDENT_DOMESTIC_USE,
          grid: { xs: 12, md: 6 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.domestico.condominiale.label" />
          ),
          value: AreaClassification.CONDOMINIUM_USE,
          grid: { xs: 12, md: 6 },
        },
      ],
    },
    case_2: {
      name: "case_2",
      label: <TranslatedText i18nKey="cases.sottotipo" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_4.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ISTITUTI_SCOLASTICI" />,
          value: "ISTITUTI_SCOLASTICI",
        },
        {
          label: (
            <TranslatedText i18nKey="PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA" />
          ),
          value: "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA",
        },
        {
          label: <TranslatedText i18nKey="CASE_DI_CURA_E_DI_ASSISTENZA" />,
          value: "CASE_DI_CURA_E_DI_ASSISTENZA",
        },
        {
          label: <TranslatedText i18nKey="OSPEDALI_E_STRUTTURE_OSPEDALIERE" />,
          value: "OSPEDALI_E_STRUTTURE_OSPEDALIERE",
        },
        {
          label: <TranslatedText i18nKey="PRESE_ANTINCENDIO" />,
          value: "PRESE_ANTINCENDIO",
        },
        {
          label: <TranslatedText i18nKey="ALTRO" />,
          value: "ALTRO",
        },
        {
          label: <TranslatedText i18nKey="CARCERI" />,
          value: "CARCERI",
        },
      ],

    },

    case_2_1: {
      name: "case_2_1",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      onChange: (selected, values, setFieldValue) => {
        console.log('hello')
        if (selected) {
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA" />,
          value: "SCUOLA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_INFANZIA" />,
          value: "SCUOLA_INFANZIA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_PRIMARIA" />,
          value: "SCUOLA_PRIMARIA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_SECONDARIA_I_grado" />,
          value: "SCUOLA_SECONDARIA_I_grado",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_SECONDARIA_II_grado" />,
          value: "SCUOLA_SECONDARIA_II_grado",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_PALESTRA" />,
          value: "SCUOLA_PALESTRA",
        },
        {
          label: <TranslatedText i18nKey="UNIVERSITA" />,
          value: "UNIVERSITA",
        },
      ],
    },

    case_2_2: {
      name: "case_2_2",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_AEREONAUTICA" />,
          value: "CASERMA_AEREONAUTICA",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_CARABINIERI" />,
          value: "CASERMA_CARABINIERI",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_GUARDIA_FINANZA" />,
          value: "CASERMA_GUARDIA_FINANZA",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_VIGILI_DEL_FUOCO" />,
          value: "CASERMA_VIGILI_DEL_FUOCO",
        },
        {
          label: <TranslatedText i18nKey="POLIZIA_LOCALE" />,
          value: "POLIZIA_LOCALE",
        },
        {
          label: <TranslatedText i18nKey="PRETURA" />,
          value: "PRETURA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_PROTEZIONE_CIVILE" />,
          value: "CENTRO_PROTEZIONE_CIVILE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_2_3: {
      name: "case_2_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AMBULATORIO_COMUNALE" />,
          value: "AMBULATORIO_COMUNALE",
        },
        {
          label: <TranslatedText i18nKey="CASA_DI_CURA" />,
          value: "CASA_DI_CURA",
        },
        {
          label: <TranslatedText i18nKey="CASA_DI_RIPOSO" />,
          value: "CASA_DI_RIPOSO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_2_4: {
      name: "case_2_4",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_SANITARIA" />,
          value: "AZIENDA_SANITARIA",
        },
        {
          label: <TranslatedText i18nKey="OSPEDALE" />,
          value: "OSPEDALE",
        },
        {
          label: <TranslatedText i18nKey="CROCE_ROSSA_CROCE_BIANCA" />,
          value: "CROCE_ROSSA_CROCE_BIANCA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_3: {
      name: "case_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="PRESA_ANTINCENDIO_CON_CONTATORE" />,
          value: "PRESA_ANTINCENDIO_CON_CONTATORE",
        },
        {
          label: <TranslatedText i18nKey="PRESA_ANTINCENDIO_SENZA_CONTATORE" />,
          value: "PRESA_ANTINCENDIO_SENZA_CONTATORE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_3_1: {
      name: "case_3_1",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AREA_ATTREZZATA_CANI" />,
          value: "AREA_ATTREZZATA_CANI",
        },
        {
          label: <TranslatedText i18nKey="AREA_MANIFESTAZIONI" />,
          value: "AREA_MANIFESTAZIONI",
        },
        {
          label: <TranslatedText i18nKey="AREA_MERCATO" />,
          value: "AREA_MERCATO",
        },
        {
          label: <TranslatedText i18nKey="AREA_PARCHEGGI" />,
          value: "AREA_PARCHEGGI",
        },
        {
          label: <TranslatedText i18nKey="AREA_PUBBLICA" />,
          value: "AREA_PUBBLICA",
        },
        {
          label: <TranslatedText i18nKey="AUDITORIUM" />,
          value: "AUDITORIUM",
        },
        {
          label: <TranslatedText i18nKey="BAGNI_PUBBLICI" />,
          value: "BAGNI_PUBBLICI",
        },
        {
          label: <TranslatedText i18nKey="BIBLIOTECA" />,
          value: "BIBLIOTECA",
        },
        {
          label: <TranslatedText i18nKey="CABINA_ELETTRICA_GAS_METANO" />,
          value: "CABINA_ELETTRICA_GAS_METANO",
        },
        {
          label: <TranslatedText i18nKey="CAMPO_NOMADI" />,
          value: "CAMPO_NOMADI",
        },
        {
          label: <TranslatedText i18nKey="CENTRALE_TERMICA" />,
          value: "CENTRALE_TERMICA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_ANZIANI" />,
          value: "CENTRO_ANZIANI",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_CIVICO" />,
          value: "CENTRO_CIVICO",
        },
        {
          label: <TranslatedText i18nKey="CIMITERO" />,
          value: "CIMITERO",
        },
        {
          label: <TranslatedText i18nKey="CINEMA_TEATRO" />,
          value: "CINEMA_TEATRO",
        },
        {
          label: <TranslatedText i18nKey="DEPOSITO_BICICLETTE" />,
          value: "DEPOSITO_BICICLETTE",
        },
        {
          label: <TranslatedText i18nKey="ECOCENTRO" />,
          value: "ECOCENTRO",
        },
        {
          label: <TranslatedText i18nKey="EDIFICI_COMUNALI" />,
          value: "EDIFICI_COMUNALI",
        },
        {
          label: <TranslatedText i18nKey="ENTE_PUBBLICO" />,
          value: "ENTE_PUBBLICO",
        },
        {
          label: <TranslatedText i18nKey="IMPIANTO_SPORTIVO" />,
          value: "IMPIANTO_SPORTIVO",
        },
        {
          label: <TranslatedText i18nKey="IMPIANTO_SPORTIVO_PISCINA" />,
          value: "IMPIANTO_SPORTIVO_PISCINA",
        },
        {
          label: <TranslatedText i18nKey="MAGAZZINO_COMUNALE" />,
          value: "MAGAZZINO_COMUNALE",
        },

        {
          label: <TranslatedText i18nKey="MENSA" />,
          value: "MENSA",
        },

        {
          label: <TranslatedText i18nKey="MUSEO" />,
          value: "MUSEO",
        },

        {
          label: <TranslatedText i18nKey="PULIZIA_STRADE" />,
          value: "PULIZIA_STRADE",
        },
        {
          label: <TranslatedText i18nKey="SEDE_COMUNALE" />,
          value: "SEDE_COMUNALE",
        },
      ],
    },
    case_4: {
      name: "case_4",
      label: <TranslatedText i18nKey="cases.sottotipo" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="USO_DIVERSO" />,
          value: "USO_DIVERSO",
        },
        {
          label: (
            <TranslatedText i18nKey="USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE" />
          ),
          value: "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
        },
        {
          label: <TranslatedText i18nKey="USO_IRRIGUO_E_COLLETTIVO" />,
          value: "USO_IRRIGUO_E_COLLETTIVO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2.name, "")
        }
      },
    },
    case_4_1: {
      name: "case_4_1",
      label: "Tipo Uso",
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="CONDOMINIALE" />,
          value: "CONDOMINIALE",
        },
        {
          label: <TranslatedText i18nKey="PRIVATO" />,
          value: "PRIVATO",
        },
        {
          label: <TranslatedText i18nKey="CANTIERE" />,
          value: "CANTIERE",
        },
      ],

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_4_2: {
      name: "case_4_2",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ORGANIZZAZIONE_TERZO_SETTORE" />,
          value: "ORGANIZZAZIONE_TERZO_SETTORE",
        },
        {
          label: <TranslatedText i18nKey="ASSOCIAZIONE_SPORTIVA" />,
          value: "ASSOCIAZIONE_SPORTIVA",
        },
        {
          label: <TranslatedText i18nKey="CHIESA_E_LUOGO_DI_CULTO" />,
          value: "CHIESA_E_LUOGO_DI_CULTO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_4_3: {
      name: "case_4_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="IRRIGAZIONE_PUBBLICA" />,
          value: "IRRIGAZIONE_PUBBLICA",
        },
        {
          label: <TranslatedText i18nKey="IRRIGAZIONE_PRIVATA" />,
          value: "IRRIGAZIONE_PRIVATA",
        },
        {
          label: <TranslatedText i18nKey="CASA_DELL_ACQUA" />,
          value: `CASA_DELL_ACQUA`,
        },
        {
          label: <TranslatedText i18nKey="FONTANELLA_PUBBLICA" />,
          value: "FONTANELLA_PUBBLICA",
        },
      ],

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },

    case_5: {
      name: "case_5",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ALLEVAMENTO_ANIMALI" />,
          value: "ALLEVAMENTO_ANIMALI",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_AGRICOLA" />,
          value: "AZIENDA_AGRICOLA",
        },
        {
          label: <TranslatedText i18nKey="FLORICOLTURA" />,
          value: "FLORICOLTURA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_6: {
      name: "case_6",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: <TranslatedText i18nKey="AGENZIA_ASSICURAZIONI" />,
          value: "AGENZIA_ASSICURAZIONI",
        },
        {
          label: <TranslatedText i18nKey="ALBERGHI_E_STRUTTURE_SIMILI" />,
          value: "ALBERGHI_E_STRUTTURE_SIMILI",
        },
        {
          label: <TranslatedText i18nKey="ATTIVITA_IMMOBILIARI" />,
          value: `ATTIVITA_IMMOBILIARI`,
        },
        {
          label: <TranslatedText i18nKey="AUTOFFICINA" />,
          value: "AUTOFFICINA",
        },
        {
          label: <TranslatedText i18nKey="AUTOLAVAGGIO" />,
          value: "AUTOLAVAGGIO",
        },
        {
          label: <TranslatedText i18nKey="AUTONOLEGGIO" />,
          value: "AUTONOLEGGIO",
        },
        {
          label: <TranslatedText i18nKey="AUTOSCUOLA" />,
          value: "AUTOSCUOLA",
        },
        {
          label: <TranslatedText i18nKey="AUTOTRASPORTI" />,
          value: "AUTOTRASPORTI",
        },
        {
          label: <TranslatedText i18nKey="BANCA" />,
          value: "BANCA",
        },
        {
          label: <TranslatedText i18nKey="BAR_CAFFETTERIA" />,
          value: "BAR_CAFFETTERIA",
        },
        {
          label: <TranslatedText i18nKey="CARROZZERIA" />,
          value: "CARROZZERIA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_ESTETICO_BENESSERE" />,
          value: "CENTRO_ESTETICO_BENESSERE",
        },
        {
          label: <TranslatedText i18nKey="COMMERCIO_AL_DETTAGLIO" />,
          value: "COMMERCIO_AL_DETTAGLIO",
        },
        {
          label: <TranslatedText i18nKey="CONCESSIONARIA_AUTO" />,
          value: "CONCESSIONARIA_AUTO",
        },
        {
          label: (
            <TranslatedText i18nKey="CONDOMINIO_INDUSTRIALE_COMMERCIALE" />
          ),
          value: "CONDOMINIO_INDUSTRIALE_COMMERCIALE",
        },
        {
          label: <TranslatedText i18nKey="DISTRIBUTORE_CARBURANTI" />,
          value: "DISTRIBUTORE_CARBURANTI",
        },
        {
          label: <TranslatedText i18nKey="FALEGNAMERIA" />,
          value: "FALEGNAMERIA",
        },
        {
          label: <TranslatedText i18nKey="FARMACIA_PARAFARMACIA" />,
          value: "FARMACIA_PARAFARMACIA",
        },
        {
          label: <TranslatedText i18nKey="FIORISTA" />,
          value: "FIORISTA",
        },
        {
          label: (
            <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_FERROVIARIE" />
          ),
          value: "GESTIONE_INFRASTRUTTURE_FERROVIARIE",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_STRADALI" />,
          value: "GESTIONE_INFRASTRUTTURE_STRADALI",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_STRADALI" />,
          value: "GESTIONE_INFRASTRUTTURE_STRADALI",
        },
        {
          label: <TranslatedText i18nKey="GRANDE_DISTRIBUZIONE_ORGANIZZATA" />,
          value: "GRANDE_DISTRIBUZIONE_ORGANIZZATA",
        },
        {
          label: <TranslatedText i18nKey="IMPRESA_COSTRUZIONI" />,
          value: "IMPRESA_COSTRUZIONI",
        },
        {
          label: <TranslatedText i18nKey="ISTITUTO_BANCARIO" />,
          value: "ISTITUTO_BANCARIO",
        },
        {
          label: <TranslatedText i18nKey="LABORATORIO_ANALISI" />,
          value: "LABORATORIO_ANALISI",
        },
        {
          label: <TranslatedText i18nKey="LAVANDERIA" />,
          value: "LAVANDERIA",
        },
        {
          label: <TranslatedText i18nKey="LAVANDERIA_INDUSTRIALE" />,
          value: "LAVANDERIA_INDUSTRIALE",
        },
        {
          label: <TranslatedText i18nKey="MAGAZZINI_E_LOGISTICA" />,
          value: "MAGAZZINI_E_LOGISTICA",
        },
        {
          label: <TranslatedText i18nKey="OFFICINA" />,
          value: "OFFICINA",
        },
        {
          label: <TranslatedText i18nKey="PANETTERIA" />,
          value: "PANETTERIA",
        },
        {
          label: <TranslatedText i18nKey="PARRUCCHIERE" />,
          value: "PARRUCCHIERE",
        },
        {
          label: <TranslatedText i18nKey="PASTICCERIA_GELATERIA" />,
          value: "PASTICCERIA_GELATERIA",
        },
        {
          label: <TranslatedText i18nKey="PIZZERIA" />,
          value: "PIZZERIA",
        },
        {
          label: <TranslatedText i18nKey="RISTORANTE" />,
          value: "RISTORANTE",
        },
        {
          label: <TranslatedText i18nKey="SERVIZI_DI_PULIZIA" />,
          value: "SERVIZI_DI_PULIZIA",
        },
        {
          label: <TranslatedText i18nKey="SERVIZI_POSTALI" />,
          value: "SERVIZI_POSTALI",
        },
        {
          label: <TranslatedText i18nKey="SERVIZIO_MENSA" />,
          value: "SERVIZIO_MENSA",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_MEDICO" />,
          value: "STUDIO_MEDICO",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_PROFESSIONALE" />,
          value: "STUDIO_PROFESSIONALE",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_VETERINARIO" />,
          value: "STUDIO_VETERINARIO",
        },
        {
          label: <TranslatedText i18nKey="TABACCHERIA_RICEVITORIA" />,
          value: "TABACCHERIA_RICEVITORIA",
        },
        {
          label: <TranslatedText i18nKey="TELECOMUNICAZIONI" />,
          value: "TELECOMUNICAZIONI",
        },
        {
          label: <TranslatedText i18nKey="TIPOGRAFIA" />,
          value: "TIPOGRAFIA",
        },
        {
          label: <TranslatedText i18nKey="TRAFILERIA" />,
          value: "TRAFILERIA",
        },
        {
          label: (
            <TranslatedText i18nKey="TRASMISSIONI_TELEVISIVE_E_RADIOFONICHE" />
          ),
          value: "TRASMISSIONI_TELEVISIVE_E_RADIOFONICHE",
        },
        {
          label: <TranslatedText i18nKey="TRASPORTO_FERROVIARIO" />,
          value: "TRASPORTO_FERROVIARIO",
        },
        {
          label: <TranslatedText i18nKey="TRASPORTO_PUBBLICO" />,
          value: "TRASPORTO_PUBBLICO",
        },
        {
          label: <TranslatedText i18nKey="UFFICIO_POSTALE" />,
          value: "UFFICIO_POSTALE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_7: {
      name: "case_7",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ACCIAIERIA" />,
          value: "ACCIAIERIA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_ALIMENTARE" />,
          value: "AZIENDA_ALIMENTARE",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_CALZATURIERA" />,
          value: "AZIENDA_CALZATURIERA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_CHIMICA" />,
          value: "AZIENDA_CHIMICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_FARMACEUTICA" />,
          value: "AZIENDA_FARMACEUTICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_GRAFICA" />,
          value: "AZIENDA_GRAFICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_LEGNAMI" />,
          value: "AZIENDA_LEGNAMI",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_PETROLIFERA" />,
          value: "AZIENDA_PETROLIFERA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_TESSILE" />,
          value: "AZIENDA_TESSILE",
        },
        {
          label: <TranslatedText i18nKey="CALZATURIFICIO" />,
          value: "CALZATURIFICIO",
        },
        {
          label: <TranslatedText i18nKey="CARTIERA" />,
          value: "CARTIERA",
        },
        {
          label: <TranslatedText i18nKey="CARTOTECNICA" />,
          value: "CARTOTECNICA",
        },
        {
          label: <TranslatedText i18nKey="COLORIFICIO" />,
          value: "COLORIFICIO",
        },
        {
          label: <TranslatedText i18nKey="CONCERIA" />,
          value: "CONCERIA",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_MOBILI" />,
          value: "FABBRICAZIONE_MOBILI",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_PRODOTTI_IN_METALLO" />,
          value: "FABBRICAZIONE_PRODOTTI_IN_METALLO",
        },
        {
          label: (
            <TranslatedText i18nKey="FABBRICAZIONE_PRODOTTI_PER_PULIZIA" />
          ),
          value: "FABBRICAZIONE_PRODOTTI_PER_PULIZIA",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_TUBI_E_PROFILATI" />,
          value: "FABBRICAZIONE_TUBI_E_PROFILATI",
        },
        {
          label: <TranslatedText i18nKey="FALEGNAMERIA" />,
          value: "FALEGNAMERIA",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_SERVIZIO_IDRICO" />,
          value: "GESTIONE_SERVIZIO_IDRICO",
        },
        {
          label: <TranslatedText i18nKey="IMPRESA_COSTRUZIONI" />,
          value: "IMPRESA_COSTRUZIONI",
        },
        {
          label: <TranslatedText i18nKey="LAVORAZIONE_CARNE" />,
          value: "LAVORAZIONE_CARNE",
        },
        {
          label: <TranslatedText i18nKey="LAVORAZIONE_PESCE" />,
          value: "LAVORAZIONE_PESCE",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_MATERIE_PLASTICHE" />,
          value: "PRODUZIONE_MATERIE_PLASTICHE",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_PRODOTTI_ALIMENTARI" />,
          value: "PRODUZIONE_PRODOTTI_ALIMENTARI",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_PRODOTTI_PER_ANIMALI" />,
          value: "PRODUZIONE_PRODOTTI_PER_ANIMALI",
        },
        {
          label: <TranslatedText i18nKey="RACCOLTA_SMALTIMENTO_RIFIUTI" />,
          value: "RACCOLTA_SMALTIMENTO_RIFIUTI",
        },
        {
          label: <TranslatedText i18nKey="RAFFINERIA" />,
          value: "RAFFINERIA",
        },
        {
          label: <TranslatedText i18nKey="SIDERURGIA" />,
          value: "SIDERURGIA",
        },
        {
          label: <TranslatedText i18nKey="TRASMISSIONE_ENERGIA_ELETTRICA" />,
          value: "TRASMISSIONE_ENERGIA_ELETTRICA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
        }
      },
    },

    tipologiaUsoNonDomestica: {
      name: "tipologiaUsoNonDomestica",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.label" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.industriale.label" />
          ),
          value: AreaClassification.INDUSTRIAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.agricolo.label" />
          ),
          value: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.artigianale.label" />
          ),
          value: AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.pubblico.label" />
          ),
          value: AreaClassification.PUBLIC,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.altro.label" />
          ),
          value: AreaClassification.OTHER,
          grid: { xs: 12, md: 4 },
        },
      ],
    },
    numeroResidenti: {
      name: "numeroResidenti",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.numero_residenti.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroResidenti.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      type: "input",
    },
    numeroCondominialeUnita: {
      name: "numeroCondominialeUnita",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.condominiale.unita.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    numeroCondominialeResidenti: {
      name: "numeroCondominialeResidenti",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroCondominialeResidenti.required.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroCondominialeResidenti.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    numeroCondominialeUnitaAltri: {
      name: "numeroCondominialeUnitaAltri",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroCondominialeUnitaAltri.required.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.numeroCondominialeUnitaAltri.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    tipologiaDiAttivita: {
      name: "tipologiaDiAttivita",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.tipologiaDiAttivita.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.tipologiaDiAttivita.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },

    tipologiaIntestatario: {
      name: "tipologiaIntestatario",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      label: (
        <TranslatedText i18nKey="cases.tipologia_intestatario_label.step5_1" />
      ),
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_professionista_5_1" />
          ),
          value: TipologiaIntestatario.PROFESSIONISTA,
          grid: { xs: 12 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_microimpresa_5_1" />
          ),
          value: TipologiaIntestatario.MICROIMPRESA,
          grid: { xs: 12 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_nessuno_5_1" />
          ),
          value: TipologiaIntestatario.NESSUNA,
          grid: { xs: 12 },
        },
      ],
    },
    // step 5.2

    estremiDelDocumento: {
      name: "estremiDelDocumento",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_2.estremiDelDocumento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    estremiDelDocumento1: {
      name: "estremiDelDocumento1",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step5_2.estremiDelDocumento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },


    // step 6
    bollettaOnlineAttiva: {
      name: "bollettaOnlineAttiva",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step6_1.bollettaOnlineAttiva.label" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "checkbox",
    },

    // step 7
    bollettaAddebitoBancario: {
      name: "bollettaAddebitoBancario",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.bolletta_addebito_bancario.label" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "checkbox",
    },
    cognomeNomeDelConto: {
      name: "cognomeNomeDelConto",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.cognome_del_conto.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.cognome_del_conto.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
    },
    codiceFiscaleTitolare: {
      name: "codiceFiscaleTitolare",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.codice_fiscale_titolare.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      uppercase: true,
      type: "input",
    },
    indirizzoDomiciliazione: {
      name: "indirizzoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(indirizzoDomiciliazione.name, isStreetValid ? `${components.via}, ${components.civico}, ${components.comune}` : '');
        egonCodeResponse.tipo_Indirizzo = "domiciliazione";
        indirizzoDomiciliazione.egonCodeResponse = egonCodeResponse;
      },
      step : "7",
    },
    telefonoDomiciliazione: {
      name: "telefonoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.telefono.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    cellulareDomiciliazione: {
      name: "cellulareDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bankName: {
      name: "bankName",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.nome_banca.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.nome_banca.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    agencia: {
      name: "agencia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.agenzia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.agenzia.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    iban: {
      name: 'iban',
      label: <TranslatedText i18nKey="cases.voltura.iban.label" />,
      labelButton: <TranslatedText i18nKey="cases.voltura.iban.labelButton.validation.text" />,
      invalidErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.not_supported' />),
      requiredErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.required' />),
      modalInfoContent: <TranslatedText i18nKey="cases.voltura.iban.modalInfoContent" />,
      modalInfoButtonText: <TranslatedText i18nKey="cases.voltura.iban.modalInfoButtonText" />,
      relatedInfo: [
        { 'bankName': 'bankName' },
        { 'agency': 'agencia' }
      ],
      type: 'iban',
    },

    // step 8
    //privacy policy

    // step 9
    idType: {
      name: "idType",
      label: <TranslatedText i18nKey="cases.digitalization.idType.placeholder" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.idType.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ID" />,
          value: "ID",
        },
        {
          label: <TranslatedText i18nKey="Passport" />,
          value: "Passport",
        },
        {
          label: <TranslatedText i18nKey="Driving_licence" />,
          value: "Driving_licence",
        },
      ],
    },
    Legittima: {
      name: "Legittima",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.Legittima.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "legittima", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    codiceFiscaleDoc: {
      name: "codiceFiscaleDoc",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codiceFiscaleDoc.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "codiceFiscaleDoc", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    verbale: {
      name: "verbale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.verbale.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "verbale", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    CCIAA: {
      name: "CCIAA",
      label: <TranslatedText i18nKey="cases.request_info.fields.CCIAA.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "CCIAA", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    ID: {
      name: "ID",
      label: <TranslatedText i18nKey="cases.request_info.fields.ID.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      // prefixFileName: 'voltura', //this set for analisi acqua
      prefixFileNameFromInternalFiledName: "idType",
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    Fattura: {
      name: "Fattura",
      label: <TranslatedText i18nKey="cases.request_info.fields.Fattura.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: 'Fattura', //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    dichiarazione: {
      name: "dichiarazione",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.dichiarazione.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "dichiarazione", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
  },
};

const {
  formField: {
    // step 1.1
    comune,
    via,
    numeroCivico,
    tipologia,

    // step 1.2
    tipoIntestatario,
    fisicaNome,
    fisicaCognome,
    fisicaCodiceFiscale,
    fisicaNatoA,
    fisicaDataNascita,
    fisicaSesso,
    fisicaComuneResidenza,
    fisicaProvincia,
    fisicaCAP,
    fisicaIndirizzo,
    businessName,
    giuridicaCodiceFiscale,
    giuridicaPartitaIVA,
    giuridicaPartitaIVA2,
    giuridicaPartitaIVAGrupoCheckbox,
    giuridicaPartitaIVAGrupo,
    giuridicaNome,
    giuridicaCognome,
    giuridicaIndirizzo,
    giuridicaSedeLegaleComune,
    giuridicaProvincia,
    giuridicaCAP,

    // step 2.1
    paCode,
    userRole,
    pec,
    cigCode,
    cupCode,
    splitPaymentCat,
    sdiCode,

    // step 3.1
    signValue,
    bollettaRecapitoTipo,
    bollettaRecapitoNuovoIndirizzo,
    bollettaPuntoDiFurnitura,
    bollettaDatiIntestatario,
    bollettaEsistenteIndirizzo,
    bollettaEsistenteComune,
    bollettaEsistenteCap,
    bollettaEsistenteProvincia,
    bollettaNomePresso,
    bollettaCognomePresso,
    bollettaEsistenteFisso,
    bollettaEsistenteCellulare,
    bollettaEsistenteEmail,
    bollettaEsistentePec,
    bollettaNuovoIndirizzo,
    bollettaNuovoComune,
    bollettaNuovoCap,
    bollettaNuovoProvincia,
    bollettaNuovoPresso,
    bollettaNuovoFisso,
    bollettaNuovoCellulare,
    bollettaNuovoEmail,
    bollettaConfirmEmail,
    bollettaConfirmNuovoEmail,
    bollettaNuovoPec,

    // step 4.1
    datiImmobile_cognomeNomeRecapito,
    datiImmobile_codiceFiscale,
    datiImmobile_partitaIva,
    datiImmobile_indirizzoCivico,
    datiImmobile_comune,
    datiImmobile_cap,
    datiImmobile_provincia,
    datiImmobile_cellulare,
    datiImmobile_fisso,
    datiImmobile_email,

    // step 4.2
    inQualitaDi,
    inQualitaDi_altro,
    ilSottoscrittoNome,
    ilSottoscrittoCognome,
    dichiaro_diEssereIntestatario,
    dichiaro_diEssereIntestatario_numero,
    dichiaro_diEssereIntestatario_data,
    dichiaro_possessoImmobile,
    dichiaro_possessoImmobile_data,
    dichiaro_rilasciatoPermesso,
    dichiaro_rilasciatoPermesso_numero,
    dichiaro_rilasciatoPermesso_data,
    dichiaro_presentataDia,
    dichiaro_presentataDia_numero,
    dichiaro_presentataDia_data,
    dichiaro_presentataScia,
    dichiaro_presentataScia_numero,
    dichiaro_presentataScia_data,
    dichiaro_dataCostruzioneIdonea,
    dichiaro_dataCostruzioneIdonea_data,
    dichiaro_presaEsistente,
    dichiaro_presaEsistente_numero,
    dichiaro_presaEsistente_data,
    dichiaro_altro,
    dichiaro_altro_testo,
    // step 4.3
    datiCatastali_tipologia,
    datiCatastali_comune,
    datiCatastali_provincia,
    datiCatastali_comuneCatastale,
    datiCatastali_provinciaComuneCatastale,
    datiCatastali_indirizzo,
    datiCatastali_civico,
    datiCatastali_edificio,
    datiCatastali_scale,
    datiCatastali_piano,
    datiCatastali_appartamento,
    datiCatastali_codiceComuneCatastale,
    datiCatastali_sezioneUrbana,
    datiCatastali_foglio,
    datiCatastali_particella,
    datiCatastali_subalterno,

    // step 5.1
    tipologiaUso,
    tipologiaUsoDomestica,
    tipologiaUsoNonDomestica,
    numeroResidenti,
    numeroCondominialeUnita,
    numeroCondominialeResidenti,
    numeroCondominialeUnitaAltri,
    tipologiaDiAttivita,
    tipologiaIntestatario,
    case_2,
    case_2_1,
    case_2_2,
    case_2_3,
    case_2_4,
    case_3,
    case_3_1,
    case_4,
    case_4_1,
    case_4_2,
    case_4_3,
    case_5,
    case_6,
    case_7,

    // step 5.2
    estremiDelDocumento,
    estremiDelDocumento1,

    // step 6
    bollettaOnlineAttiva,

    // step 7
    bollettaAddebitoBancario,
    cognomeNomeDelConto,
    codiceFiscaleTitolare,
    bankName,
    indirizzoDomiciliazione,
    telefonoDomiciliazione,
    cellulareDomiciliazione,
    agencia,
    iban,

    // step 8
    //privacy policy

    // step 9
    Legittima,
    codiceFiscaleDoc,
    verbale,
    CCIAA,
    ID,
    Fattura,
    idType,
    dichiarazione,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [comune.name]: "",
  [via.name]: "",
  [numeroCivico.name]: "",
  [tipologia.name]: CaseSubTypes.WATER,

  // step 1.2
  [tipoIntestatario.name]: PersonType.NATURAL,
  [fisicaNome.name]: "",
  [fisicaCognome.name]: "",
  [fisicaCodiceFiscale.name]: "",
  [fisicaNatoA.name]: "",
  [fisicaDataNascita.name]: "",
  [fisicaSesso.name]: PersonSex.M,
  [fisicaComuneResidenza.name]: "",
  [fisicaProvincia.name]: "",
  [giuridicaProvincia.name]: "",
  [fisicaCAP.name]: "",
  [fisicaIndirizzo.name]: "",
  [businessName.name]: "",
  [giuridicaCodiceFiscale.name]: "",
  [giuridicaPartitaIVA.name]: "",
  [giuridicaPartitaIVA2.name]: "",
  [giuridicaPartitaIVAGrupoCheckbox.name]: false,
  [giuridicaPartitaIVAGrupo.name]: "",
  [giuridicaNome.name]: "",
  [giuridicaCognome.name]: "",
  [giuridicaIndirizzo.name]: "",
  [giuridicaSedeLegaleComune.name]: "",
  [giuridicaProvincia.name]: "",
  [giuridicaCAP.name]: "",

  // step 2.1
  [paCode.name]: "",
  [userRole.name]: "",
  [pec.name]: "",
  [cigCode.name]: "",
  [cupCode.name]: "",
  [splitPaymentCat.name]: "",
  [sdiCode.name]: "",

  // step 3.1
  [signValue.name]: '',
  // bollettaRecapitoNuovoIndirizzo needs to be before bollettaRecapitoTipo so that the default value can stay
  [bollettaRecapitoNuovoIndirizzo.name]: "",
  [bollettaRecapitoTipo.name]: TipoBollettaRecapito.PRE_ESISTENTE,
  [bollettaPuntoDiFurnitura.name]: "",
  [bollettaDatiIntestatario.name]: "",
  [bollettaEsistenteIndirizzo.name]: "",
  [bollettaEsistenteComune.name]: "",
  [bollettaEsistenteCap.name]: "",
  [bollettaEsistenteProvincia.name]: "",
  [bollettaNomePresso.name]: "",
  [bollettaCognomePresso.name]: "",
  [bollettaEsistenteFisso.name]: "",
  [bollettaEsistenteCellulare.name]: "",
  [bollettaEsistenteEmail.name]: "",
  [bollettaEsistentePec.name]: "",
  [bollettaNuovoIndirizzo.name]: "",
  [bollettaNuovoComune.name]: "",
  [bollettaNuovoCap.name]: "",
  [bollettaNuovoProvincia.name]: "",
  [bollettaNuovoPresso.name]: "",
  [bollettaNuovoFisso.name]: "",
  [bollettaNuovoCellulare.name]: "",
  [bollettaNuovoEmail.name]: "",
  [bollettaConfirmEmail.name]: "",
  [bollettaConfirmNuovoEmail.name]: "",
  [bollettaNuovoPec.name]: "",

  // step 4.1
  [datiImmobile_cognomeNomeRecapito.name]: "",
  [datiImmobile_codiceFiscale.name]: "",
  [datiImmobile_partitaIva.name]: "",
  [datiImmobile_indirizzoCivico.name]: "",
  [datiImmobile_comune.name]: "",
  [datiImmobile_cap.name]: "",
  [datiImmobile_provincia.name]: "",
  [datiImmobile_cellulare.name]: "",
  [datiImmobile_fisso.name]: "",
  [datiImmobile_email.name]: "",

  // step 4.2
  [inQualitaDi.name]: AccountHolderType.OWNER,
  [inQualitaDi_altro.name]: "",
  [ilSottoscrittoNome.name]: "",
  [ilSottoscrittoCognome.name]: "",
  [dichiaro_diEssereIntestatario.name]: true,
  [dichiaro_diEssereIntestatario_numero.name]: "",
  [dichiaro_diEssereIntestatario_data.name]: "",
  [dichiaro_possessoImmobile.name]: false,
  [dichiaro_possessoImmobile_data.name]: "",
  [dichiaro_rilasciatoPermesso.name]: false,
  [dichiaro_rilasciatoPermesso_numero.name]: "",
  [dichiaro_rilasciatoPermesso_data.name]: "",
  [dichiaro_presentataDia.name]: false,
  [dichiaro_presentataDia_numero.name]: "",
  [dichiaro_presentataDia_data.name]: "",
  [dichiaro_presentataScia.name]: false,
  [dichiaro_presentataScia_numero.name]: "",
  [dichiaro_presentataScia_data.name]: "",
  [dichiaro_dataCostruzioneIdonea.name]: false,
  [dichiaro_dataCostruzioneIdonea_data.name]: "",
  [dichiaro_presaEsistente.name]: false,
  [dichiaro_presaEsistente_numero.name]: "",
  [dichiaro_presaEsistente_data.name]: "",
  [dichiaro_altro.name]: false,
  [dichiaro_altro_testo.name]: "",
  // step 4.3
  [datiCatastali_tipologia.name]: CadastreType.MANUFACTURED,
  [datiCatastali_comune.name]: "",
  [datiCatastali_provincia.name]: "",
  [datiCatastali_comuneCatastale.name]: "",
  [datiCatastali_provinciaComuneCatastale.name]: "",
  [datiCatastali_indirizzo.name]: "",
  [datiCatastali_civico.name]: "",
  [datiCatastali_edificio.name]: "",
  [datiCatastali_scale.name]: "",
  [datiCatastali_piano.name]: "",
  [datiCatastali_appartamento.name]: "",
  [datiCatastali_codiceComuneCatastale.name]: "",
  [datiCatastali_sezioneUrbana.name]: "",
  [datiCatastali_foglio.name]: "",
  [datiCatastali_particella.name]: "",
  [datiCatastali_subalterno.name]: "",

  // step 5.1
  [tipologiaUso.name]: TipologiaUsoFornitura.DOMESTICO,
  [tipologiaUsoDomestica.name]: AreaClassification.RESIDENT_DOMESTIC_USE,
  [tipologiaUsoNonDomestica.name]: AreaClassification.INDUSTRIAL_USE,
  [numeroResidenti.name]: "",
  [numeroCondominialeUnita.name]: "",
  [numeroCondominialeResidenti.name]: "",
  [numeroCondominialeUnitaAltri.name]: "",
  [tipologiaDiAttivita.name]: "",
  [case_2.name]: "",
  [case_2_1.name]: "",
  [case_2_2.name]: "",
  [case_2_3.name]: "",
  [case_2_4.name]: "",
  [case_3.name]: "",
  [case_3_1.name]: "",
  [case_4.name]: "",
  [case_4_1.name]: "",
  [case_4_2.name]: "",
  [case_4_3.name]: "",
  [case_5.name]: "",
  [case_6.name]: "",
  [case_7.name]: "",

  // step 5.1
  [estremiDelDocumento.name]: "",
  [estremiDelDocumento1.name]: "",
  [tipologiaIntestatario.name]: "",

  // step 6.1
  [bollettaOnlineAttiva.name]: false,

  // step 7.1
  [bollettaAddebitoBancario.name]: false,
  [cognomeNomeDelConto.name]: "",
  [codiceFiscaleTitolare.name]: "",
  [bankName.name]: "",
  [indirizzoDomiciliazione.name]: "",
  [telefonoDomiciliazione.name]: "",
  [cellulareDomiciliazione.name]: "",
  [agencia.name]: "",
  [iban.name]: "",

  // step 8.1
  //privacy policy

  // step 9
  [Legittima.name]: "",
  [codiceFiscaleDoc.name]: "",
  [verbale.name]: "",
  [CCIAA.name]: "",
  [ID.name]: "",
  [Fattura.name]: "",
  [idType.name]: "",
  [dichiarazione.name]: "",
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const GetValidationSchema = (props) => {
  const validationFiscalCode = getValidationRule("fiscalCode");
  const validationEmail = getValidationRule("email");
  const validationFiscalCodeOrVAT = getValidationRule("fiscalCodeOrVAT");
  const validationPhone = getValidationRule("phone");
  const validationNumber = getValidationRule("number");
  const validationBusinessName = getValidationObject("businessName");


  return [
    // step 1.1
    Yup.object().shape({
      [comune.name]: Yup.string().required(
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      [via.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [numeroCivico.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [tipologia.name]: Yup.string().required(
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
    }),
    // step 1.2
    Yup.object().shape({
      [tipoIntestatario.name]: Yup.string()
        .oneOf(
          tipoIntestatario.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      // NATURAL Person
      [fisicaNome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaCognome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaNatoA.name]: Yup.string().when([tipoIntestatario.name], {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaCodiceFiscale.name]: Yup.string().when([tipoIntestatario.name, fisicaNatoA.name], {
        is: (field, fisicaNatoA) => field === PersonType.NATURAL && !fisicaNatoA,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCode, {
            message: fisicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [fisicaIndirizzo.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      }),
      [fisicaDataNascita.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(fisicaDataNascita.requiredErrorMsg),
      }),
      [fisicaSesso.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .oneOf(
            fisicaSesso.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(
            <TranslatedText i18nKey="cases.request_info.errors.required" />
          ),
      }),
      [fisicaComuneResidenza.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaProvincia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true).max(2, <TranslatedText i18nKey="province.length" />)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaCAP.name]: Yup.number().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.number()
          .typeError(fisicaCAP.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      // LEGAL person
      [businessName.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .matches(validationBusinessName.regex
            , {
              message: (
                <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
              ),
            })

          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaCodiceFiscale.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVA.name], {
        is: (field, giuridicaPartitaIVA) => field === PersonType.LEGAL && !giuridicaPartitaIVA,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaPartitaIVA2.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, giuridicaPartitaIVAGrupoCheckbox) => field === PersonType.LEGAL && giuridicaPartitaIVAGrupoCheckbox,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [giuridicaProvincia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true).max(2, <TranslatedText i18nKey="province.length" />)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [giuridicaPartitaIVAGrupo.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, checkbox) => field === PersonType.LEGAL && checkbox === true,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [giuridicaNome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaCognome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaIndirizzo.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string().required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      }),
      [giuridicaSedeLegaleComune.name]: Yup.string().when(
        tipoIntestatario.name,
        {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [giuridicaCAP.name]: Yup.number().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.number()
          .typeError(giuridicaCAP.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
    }),
    //step 2.1
    Yup.object().shape({

      [giuridicaPartitaIVA.name]: Yup.string().when([tipoIntestatario.name, giuridicaCodiceFiscale.name], {
        is: (field, giuridicaCodiceFiscale) => field === PersonType.LEGAL && !giuridicaCodiceFiscale,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [pec.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationEmail, { message: pec.invalidErrorMsg }),
      [paCode.name]: Yup.string().when(userRole.name, {
        is: UserRoleEnum.MUNICIPAL_USER,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(paCode.requiredErrorMsg),
      }),
    }),
    // step 3.1
    Yup.object().shape({
      sign: Yup.boolean(),
      // Existing Address
      [bollettaEsistenteCellulare.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: bollettaEsistenteCellulare.invalidErrorMsg,
            })
            .required(bollettaEsistenteCellulare.requiredErrorMsg),
        }
      ),
      [bollettaEsistenteEmail.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationEmail, {
              message: bollettaEsistenteEmail.invalidErrorMsg,
            })
            .required(bollettaEsistenteEmail.requiredErrorMsg),
        }
      ),
      [bollettaEsistenteComune.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [bollettaEsistenteCap.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [bollettaEsistenteProvincia.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [bollettaEsistenteFisso.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: bollettaEsistenteFisso.invalidErrorMsg,
            }),
        }
      ),
      [bollettaEsistentePec.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationEmail, {
              message: bollettaEsistentePec.invalidErrorMsg,
            }),
        }
      ),
      // old address
      [bollettaNuovoCellulare.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: bollettaNuovoCellulare.invalidErrorMsg,
            })
            .required(bollettaNuovoCellulare.requiredErrorMsg),
        }
      ),
      [bollettaNuovoEmail.name]: Yup.string().when(bollettaRecapitoTipo.name, {
        is: (field) => field === TipoBollettaRecapito.NUOVO,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .matches(validationEmail, {
            message: bollettaNuovoEmail.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [bollettaConfirmEmail.name]: Yup.string().when([signValue.name, bollettaRecapitoTipo.name], {
        is: (signValue, bollettaRecapitoTipo) => signValue === true && bollettaRecapitoTipo === TipoBollettaRecapito.PRE_ESISTENTE,
        then: Yup.string()
          .oneOf(
            [Yup.ref("bollettaEsistenteEmail"), null],
            <TranslatedText i18nKey="cases.request_info.email.match" />
          )
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          )
      }),
      [bollettaConfirmNuovoEmail.name]: Yup.string().when([signValue.name, bollettaRecapitoTipo.name], {
        is: (signValue, bollettaRecapitoTipo) => signValue === true && bollettaRecapitoTipo === TipoBollettaRecapito.NUOVO,
        then: Yup.string()
          .oneOf(
            [Yup.ref("bollettaNuovoEmail"), null],
            <TranslatedText i18nKey="cases.request_info.email.match" />
          )
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          )
      }),


      [bollettaNuovoComune.name]: Yup.string().when(bollettaRecapitoTipo.name, {
        is: (field) => field === TipoBollettaRecapito.NUOVO,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [bollettaNuovoProvincia.name]: Yup.string().when(
        bollettaRecapitoTipo.name,
        {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [bollettaNuovoFisso.name]: Yup.string().when(bollettaRecapitoTipo.name, {
        is: (field) => field === TipoBollettaRecapito.NUOVO,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .matches(validationPhone, {
            message: bollettaNuovoFisso.invalidErrorMsg,
          }),
      }),
      [bollettaNuovoCap.name]: Yup.number().when(bollettaRecapitoTipo.name, {
        is: (field) => field === TipoBollettaRecapito.NUOVO,
        then: Yup.number()
          .typeError(bollettaNuovoCap.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [bollettaNuovoPec.name]: Yup.string().when(bollettaRecapitoTipo.name, {
        is: (field) => field === TipoBollettaRecapito.NUOVO,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .matches(validationEmail, {
            message: bollettaNuovoPec.invalidErrorMsg,
          }),
      }),
    }),
    // step 4.1
    Yup.object().shape({
      [datiImmobile_cognomeNomeRecapito.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationBusinessName.regex
          , {
            message: (
              <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
            ),
          })
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiImmobile_comune.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiImmobile_provincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiImmobile_cellulare.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationPhone, {
          message: (
            <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
          ),
        })
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiImmobile_fisso.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationPhone, {
          message: (
            <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
          ),
        }),
      [datiImmobile_email.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationEmail, {
          message: datiImmobile_email.invalidErrorMsg,
        })
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiImmobile_partitaIva.name]: Yup.string()
        .min(
          11,
          <TranslatedText i18nKey="errors.registration.public.fc.short" />
        )
        .max(
          11,
          <TranslatedText i18nKey="errors.registration.public.fc.long" />
        )
        .matches(validationNumber, {
          message: (
            <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
          ),
        }),
      [datiImmobile_codiceFiscale.name]: Yup.string()
        .min(
          11,
          <TranslatedText i18nKey="errors.registration.public.fc.short" />
        )
        .max(
          16,
          <TranslatedText i18nKey="errors.registration.public.fc.long" />
        )
        .matches(validationFiscalCode, {
          message: (
            <TranslatedText i18nKey="errors.registration.public.fc.match" />
          ),
        }),
    }),
    // step 4.2
    Yup.object()
      .shape({
        [inQualitaDi.name]: Yup.string()
          .oneOf(
            inQualitaDi.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(
            <TranslatedText i18nKey="cases.request_info.errors.required" />
          ),
        [ilSottoscrittoNome.name]: Yup.string().when(inQualitaDi.name, {
          is: (field) => field === AccountHolderType.OWNER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(ilSottoscrittoNome.requiredErrorMsg),
        }),
        [ilSottoscrittoCognome.name]: Yup.string().when(inQualitaDi.name, {
          is: (field) => field === AccountHolderType.OWNER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(ilSottoscrittoCognome.requiredErrorMsg),
        }),
        [dichiaro_diEssereIntestatario_numero.name]: Yup.string().when(
          dichiaro_diEssereIntestatario.name,
          {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }
        ),
        [dichiaro_diEssereIntestatario_data.name]: Yup.string().when(
          dichiaro_diEssereIntestatario.name,
          {
            is: (field) => field === true,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              ),
          }
        ),
        [dichiaro_possessoImmobile_data.name]: Yup.string().when(
          dichiaro_possessoImmobile.name,
          {
            is: (field) => field === true,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              ),
          }
        ),
        [dichiaro_rilasciatoPermesso_numero.name]: Yup.string().when(
          dichiaro_rilasciatoPermesso.name,
          {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }
        ),
        [dichiaro_rilasciatoPermesso_data.name]: Yup.string().when(
          dichiaro_rilasciatoPermesso.name,
          {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }
        ),
        [dichiaro_presentataDia_numero.name]: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .when(dichiaro_presentataDia.name, {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }),
        [dichiaro_presentataDia_data.name]: Yup.string().when(
          dichiaro_presentataDia.name,
          {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }
        ),
        [dichiaro_presentataScia_numero.name]: Yup.string().when(
          dichiaro_presentataScia.name,
          {
            is: (field) => field === true,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              ),
          }
        ),
        [dichiaro_presentataScia_data.name]: Yup.string()
          .when(dichiaro_presentataScia.name, {
            is: (field) => field === true,
            then: Yup.string()
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              )
              .nullable(),
          })
          .nullable(),
        [dichiaro_dataCostruzioneIdonea_data.name]: Yup.string().when(
          dichiaro_dataCostruzioneIdonea.name,
          {
            is: (field) => field === true,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              ),
          }
        ),
        [dichiaro_presaEsistente_numero.name]: Yup.string().when(
          dichiaro_presaEsistente.name,
          {
            is: (field) => field === true,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              ),
          }
        ),
        [dichiaro_presaEsistente_data.name]: Yup.string().when(
          dichiaro_presaEsistente.name,
          {
            is: (field) => field === true,
            then: Yup.string().required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
          }
        ),
        [dichiaro_altro_testo.name]: Yup.string().when(dichiaro_altro.name, {
          is: (field) => field === true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }),
        [inQualitaDi_altro.name]: Yup.string().when(inQualitaDi.name, {
          is: AccountHolderType.OTHER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }),
      })
      .test("myCustomTest", null, (value) => {
        if (
          value.dichiaro_diEssereIntestatario ||
          value.dichiaro_rilasciatoPermesso ||
          value.dichiaro_possessoImmobile ||
          value.dichiaro_presentataDia ||
          value.dichiaro_presentataScia ||
          value.dichiaro_dataCostruzioneIdonea ||
          value.dichiaro_presaEsistente ||
          value.dichiaro_altro ||
          value.inQualitaDi !== AccountHolderType.OWNER
        ) {
          return true; // everything is fine
        }
        return new Yup.ValidationError(
          (
            <TranslatedText i18nKey="cases.allacciamento.richiesta_allacciamento.selection.error_message" />
          ),
          null
        );
      }),
    // step 4.3
    Yup.object().shape({
      [datiCatastali_tipologia.name]: Yup.string()
        .oneOf(
          datiCatastali_tipologia.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [datiCatastali_provincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiCatastali_comune.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiCatastali_provinciaComuneCatastale.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiCatastali_indirizzo.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiCatastali_civico.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [datiCatastali_edificio.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_scale.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_piano.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_appartamento.name]: Yup.string().max(3, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_codiceComuneCatastale.name]: Yup.string().max(5, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_sezioneUrbana.name]: Yup.string().max(3, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_foglio.name]: Yup.string().max(4, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_particella.name]: Yup.string().max(5, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastali_subalterno.name]: Yup.string().max(4, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
    }),
    // step 5.1
    Yup.object().shape({
      [tipologiaUso.name]: Yup.string()
        .oneOf(
          tipologiaUso.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [tipologiaUsoDomestica.name]: Yup.string().when(tipologiaUso.name, {
        is: TipologiaUsoFornitura.DOMESTICO,
        then: Yup.string()
          .oneOf(
            tipologiaUsoDomestica.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [tipologiaUsoNonDomestica.name]: Yup.string().when(tipologiaUso.name, {
        is: TipologiaUsoFornitura.NON_DOMESTICO,
        then: Yup.string()
          .oneOf(
            tipologiaUsoNonDomestica.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [case_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === 'ISTITUTI_SCOLASTICI',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === 'PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === 'CASE_DI_CURA_E_DI_ASSISTENZA',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_4.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === 'OSPEDALI_E_STRUTTURE_OSPEDALIERE',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === 'PRESE_ANTINCENDIO',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_3_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "ALTRO",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_5.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica ===
            AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_6.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica ===
            AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_7.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.INDUSTRIAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.OTHER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === 'USO_DIVERSO',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === 'USO_IRRIGUO_E_COLLETTIVO',
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [numeroResidenti.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.RESIDENT_DOMESTIC_USE,
          then: Yup.number().min(1, <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min" />)
            .max(9, <TranslatedText i18nKey="cases.request_info.fields.max" />)
            .typeError(numeroResidenti.invalidErrorMsg)
            .required(numeroResidenti.requiredErrorMsg),
        }
      ),
      // [notResidentialUnits.name]: Yup.number().when(
      //   [tipologiaUso.name, tipologiaUsoDomestica.name],
      //   {
      //     is: (tipologiaUso, tipologiaUsoDomestica) =>
      //       tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
      //       tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
      //     then: Yup.number().max( 1000, <TranslatedText i18nKey="cases.request_info.fields.max1000"/>)
      //       .typeError(residentialUnits.invalidErrorMsg)
      //       .required(residentialUnits.requiredErrorMsg),
      //   }
      // ),
      [numeroCondominialeUnitaAltri.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number().max(1000, <TranslatedText i18nKey="cases.request_info.fields.max1000" />)
            .typeError(numeroCondominialeUnita.invalidErrorMsg)
            .required(numeroCondominialeUnita.requiredErrorMsg),
        }
      ),
      [numeroCondominialeUnita.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number().min(2, <TranslatedText
            i18nKey="cases.request_info.fields.notResidentialUnits.min" />).max(1000, <TranslatedText
              i18nKey="cases.request_info.fields.max1000" />)
            .typeError(numeroCondominialeUnita.invalidErrorMsg)
            .required(numeroCondominialeUnita.requiredErrorMsg),
        }
      ),
      [numeroCondominialeResidenti.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number().min(1, <TranslatedText
            i18nKey="cases.request_info.fields.lettura_decorrenza.min" />).max(1000, <TranslatedText
              i18nKey="cases.request_info.fields.max1000" />)
            .typeError(numeroCondominialeUnita.invalidErrorMsg)
            .required(numeroCondominialeUnita.requiredErrorMsg),
        }
      ),
      [tipologiaIntestatario.name]: Yup.string().when([tipologiaUso.name, tipologiaUsoNonDomestica.name], {
        is: (tipologiaUso, tipologiaUsoNonDomestica) =>
          tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO && (tipologiaUsoNonDomestica === AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE || tipologiaUsoNonDomestica === AreaClassification.ARTISAN_AND_COMMERCIAL_USE),
        then: Yup.string().oneOf(
          tipologiaIntestatario.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        ).required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      }),
    }),
    // step 5.2
    Yup.object().shape({
      [estremiDelDocumento1.name]: Yup.string().when([signValue.name,], {
        is: (signValue) => signValue === false,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
    }),
    // step 6
    Yup.object().shape({}),
    // step 7
    Yup.object().shape({
      [cognomeNomeDelConto.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationBusinessName.regex
              , {
                message: (
                  <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
                ),
              })
            .required(cognomeNomeDelConto.requiredErrorMsg),
        }
      ),
      [codiceFiscaleTitolare.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationFiscalCode, {
              message: codiceFiscaleTitolare.invalidErrorMsg,
            })
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [cellulareDomiciliazione.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: (
                <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
              ),
            })
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [telefonoDomiciliazione.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: (
                <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
              ),
            }),
        }
      ),
      [bankName.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [iban.name]: Yup.string().when(bollettaAddebitoBancario.name, {
        is: true,
        then: Yup.string()
          .required(iban.requiredErrorMsg)
          .min(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .max(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .matches(/[A-Z]/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_check" />
            ),
          })
          .matches(/IT[A-Z0-9]{2}\s?/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_digits" />
            )
          }),
      }),

    }),
    // step 8
    Yup.object().shape({}),
    //step 9
    Yup.object().shape({
      [estremiDelDocumento.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      [idType.name]: Yup.string()
        .oneOf(
          idType.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ID.name]: Yup.mixed()
        .required(<TranslatedText i18nKey="cases.errors.required" />)
        .test("fileSize", "Your file", (value) => value && value !== undefined),
      [Fattura.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) =>
          field === AccountHolderType.OTHER,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [Legittima.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) =>
          field === AccountHolderType.CONDOMINIUM_ADMIN ||
          field === AccountHolderType.USUFRUCTUARY ||
          field === AccountHolderType.TENANT ||
          field === AccountHolderType.LEGAL_REPRESENTATIVE ||
          field === AccountHolderType.OTHER,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [codiceFiscaleDoc.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [verbale.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [CCIAA.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.LEGAL_REPRESENTATIVE,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [dichiarazione.name]: Yup.mixed().when(case_2.name, {
        is: (field) => field === "PRESE_ANTINCENDIO",
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
    }),
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    // step 1.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step1_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step1_1.title" />,
      fields: [
        {
          fieldName: comune.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: via.name,
          grid: {
            xs: 6,
            md: 4,
          },
        },
        {
          fieldName: numeroCivico.name,
          grid: {
            xs: 6,
            md: 4,
          },
        },
        {
          fieldName: tipologia.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
      ],
    },
    // step 1.2
    {
      chapter: false,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step1_2.title" />,
      hooks: {
        pre: (values, setFieldValue) => {
          // step 4.1
          setFieldValue(
            datiImmobile_indirizzoCivico.name,
            `${values.via}, ${values.numeroCivico}`
          );
          // step 4.3
          setFieldValue(datiCatastali_indirizzo.name, values.via);
          setFieldValue(datiCatastali_civico.name, values.numeroCivico);
        },
      },
      fields: [
        {
          fieldName: "tipoIntestatario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "fisicaNome",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCognome",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaNatoA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaDataNascita",
          grid: {
            xs: 12,
            md: 3,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaSesso",
          grid: {
            xs: 12,
            md: 3,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaComuneResidenza",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaProvincia",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCAP",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "businessName",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: false,
            }
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA2",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },
        {
          fieldName: "giuridicaPartitaIVAGrupoCheckbox",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
          className: "align-self-center"
        },
        {
          fieldName: "giuridicaPartitaIVAGrupo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },

        {
          fieldName: "giuridicaNome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCognome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaSedeLegaleComune",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaProvincia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCAP",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
      ],
    },
    // step 2
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step2_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step2_1.title" />,
      component: FatturazioneElettronica,
      fields: [
        {
          fieldName: "sdiCode",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: null,
              is: UserRoleEnum.PRIVATE,
            },
            {
              if: null,
              is: UserRoleEnum.COMPANY,
            },
            {
              if: null,
              is: UserRoleEnum.CONDOMINIUM_ADMIN,
            },
            {
              if: null,
              is: UserRoleEnum.MANAGER,
            },
            {
              if: null,
              is: UserRoleEnum.OPERATOR,
            },
            {
              if: null,
              is: UserRoleEnum.PARTNER,
            },
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_OPERATOR,
            },
          ],
        },
        {
          fieldName: "paCode",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_USER,
            },
          ],
        },
        {
          fieldName: "pec",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "cigCode",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_USER,
            },
          ],
        },
        {
          fieldName: "cupCode",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_USER,
            },
          ],
        },
        {
          fieldName: "splitPaymentCat",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_USER,
            },
          ],
        },
      ],
    },
    // step 3.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step3_1.chapterName" />
      ),
      title: (
         <TranslatedText i18nKey="cases.allacciamento.step3_1.title" />
      ),
      hooks: {
        pre: (values, setFieldValue) => {
          setFieldValue(
            bollettaPuntoDiFurnitura.name,
            getStandardAddressFormat(
              "cases.address_suggestion.button_1",
              values.comune,
              values.via
            )
          );
          if (values[tipoIntestatario.name] === PersonType.NATURAL) {
            setFieldValue(
              "bollettaDatiIntestatario",
              getStandardAddressFormat(
                "cases.address_suggestion.button_2",
                values[fisicaComuneResidenza.name],
                values[fisicaProvincia.name],
                values[fisicaCAP.name],
                values[fisicaIndirizzo.name]
              )
            );
          } else {
            setFieldValue(
              "bollettaDatiIntestatario",
              getStandardAddressFormat(
                "cases.address_suggestion.button_2",
                values[giuridicaSedeLegaleComune.name],
                values[giuridicaProvincia.name],
                values[giuridicaCAP.name],
                values[giuridicaIndirizzo.name]
              )
            );
          }
        },
      },
      component: DigitalizzazioneDocument,
      fields: [
        {
          fieldName: "bollettaRecapitoTipo",
          grid: {
            md: 6,
            xs: 12,
          },
        },
        // New Address
        {
          fieldName: "bollettaRecapitoNuovoIndirizzo",
          grid: {
            md: 6,
            xs: 12,
          },
        },
        // Existing address
        {
          fieldName: "bollettaPuntoDiFurnitura",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaDatiIntestatario",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteComune",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteCap",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteProvincia",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaNomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: "bollettaCognomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        }, {
          fieldName: "bollettaEsistenteCellulare",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteFisso",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaEsistenteEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },

        {
          fieldName: "bollettaConfirmEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info" />}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: "bollettaEsistentePec",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoComune",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoCap",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoProvincia",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: "bollettaCognomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "bollettaNuovoCellulare",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoFisso",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaNuovoEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
        {
          fieldName: "bollettaConfirmNuovoEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info" />}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        }, {
          fieldName: "bollettaNuovoPec",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
        },
      ],
    },
    // Step 4.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step4_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step4_1.title" />,
      fields: [
        {
          fieldName: datiImmobile_cognomeNomeRecapito.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_codiceFiscale.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_partitaIva.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_indirizzoCivico.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_comune.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_cap.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_provincia.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_cellulare.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_fisso.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_email.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
      ],
    },
    //step 4.2
    {
      chapter: false,
      title: "Richiesta allacciamento",
      fields: [
        {
          fieldName: null,
          text: (
            <PlainLabel label={<TranslatedText i18nKey="cases.allacciamento.step4_2.dichiarazione" />} />
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "inQualitaDi",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.labels.ownership_details" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <PlainLabel
              label={
                <TranslatedText i18nKey="cases.voltura.labels.dichiarazione_sostitutiva" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },
        {
          fieldName: "ilSottoscrittoNome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },
        {
          fieldName: "ilSottoscrittoCognome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },

        {
          fieldName: "inQualitaDi_altro",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <PlainLabel
              label={
                <TranslatedText i18nKey="allacimanento_altro_message" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <PlainLabel
              label={
                <TranslatedText i18nKey="cases.voltura.labels.declaration_request" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },
        {
          fieldName: "dichiaro_diEssereIntestatario",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },

        {
          fieldName: "dichiaro_diEssereIntestatario_numero",
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input left step-4-3",
        },
        {
          fieldName: null,
          text: (
            <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
          ),
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start mb-3 text-center",
        },
        {
          fieldName: "dichiaro_diEssereIntestatario_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },

        {
          fieldName: "dichiaro_possessoImmobile",
          grid: {
            xs: 12,
            md: 5,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },
        {
          fieldName: "dichiaro_possessoImmobile_data",
          grid: {
            xs: 12,
            md: 3,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },

        {
          fieldName: "dichiaro_rilasciatoPermesso",
          grid: {
            xs: 12,
            md: 5,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },

        {
          fieldName: "dichiaro_rilasciatoPermesso_numero",
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input left step-4-3",
        },
        {
          fieldName: null,
          text: (
            <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
          ),
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start mb-3 text-center",
        },
        {
          fieldName: "dichiaro_rilasciatoPermesso_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },
        {
          fieldName: "dichiaro_presentataDia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },

        {
          fieldName: "dichiaro_presentataDia_numero",
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input left step-4-3",
        },
        {
          fieldName: null,
          text: (
            <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
          ),
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start mb-3 text-center",
        },
        {
          fieldName: "dichiaro_presentataDia_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },
        {
          fieldName: "dichiaro_presentataScia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },
        {
          fieldName: "dichiaro_presentataScia_numero",
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input left step-4-3",
        },
        {
          fieldName: null,
          text: (
            <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
          ),
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start mb-3 text-center",
        },
        {
          fieldName: "dichiaro_presentataScia_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },
        {
          fieldName: "dichiaro_dataCostruzioneIdonea",
          grid: {
            xs: 12,
            md: 9,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },
        {
          fieldName: "dichiaro_dataCostruzioneIdonea_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },

        {
          fieldName: "dichiaro_presaEsistente",
          grid: {
            xs: 12,
            md: 7,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },

        {
          fieldName: "dichiaro_presaEsistente_numero",
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input left step-4-3",
        },
        {
          fieldName: null,
          text: (
            <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
          ),
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start mb-3 text-center",
        },
        {
          fieldName: "dichiaro_presaEsistente_data",
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start inline-input step-4-3",
        },
        {
          fieldName: "dichiaro_altro",
          grid: {
            xs: 3,
            md: 2,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
          className: "align-self-start checkbox-group-list",
        },
        {
          fieldName: "dichiaro_altro_testo",
          className: "step-4-3",
          grid: {
            xs: 9,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OWNER,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.titles.labels.affituario" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.TENANT,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.titles.labels.building_administrator" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.titles.labels.usufruttuario" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.USUFRUCTUARY,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.titles.labels.legal_representative" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            },
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.titles.labels.other" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: "ALTRO_TITOLO",
            },
          ],
        },
      ],
    },
    // Step 4.3
    {
      chapter: false,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step4_3.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step4_3.title" />,
      fields: [
        {
          fieldName: datiCatastali_tipologia.name,
          grid: { xs: 12 },
        },
        {
          fieldName: datiCatastali_comune.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_provincia.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_comuneCatastale.name,
          grid: { xs: 12, md: 6 },
        },

        {
          fieldName: datiCatastali_provinciaComuneCatastale.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_indirizzo.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_civico.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_edificio.name,
          grid: { xs: 12, md: 4 },
        },

        {
          fieldName: datiCatastali_scale.name,
          grid: { xs: 12, md: 4 },
        },
        {
          fieldName: datiCatastali_piano.name,
          grid: { xs: 12, md: 2 },
        },
        {
          fieldName: datiCatastali_appartamento.name,
          grid: { xs: 12, md: 2 },
        },
        {
          fieldName: datiCatastali_codiceComuneCatastale.name,
          grid: { xs: 12, md: 6 },
        },

        {
          fieldName: datiCatastali_sezioneUrbana.name,
          grid: { xs: 12, md: 4 },
        },
        {
          fieldName: datiCatastali_foglio.name,
          grid: { xs: 12, md: 2 },
        },
        {
          fieldName: datiCatastali_particella.name,
          grid: { xs: 12, md: 6 },
        },
        {
          fieldName: datiCatastali_subalterno.name,
          grid: { xs: 12, md: 6 },
        },
      ],
    },
    // step 5.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step5_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.allacciamento.step5_1.title" />,
      fields: [
        {
          fieldName: "tipologiaUso",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "tipologiaUsoDomestica",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
          ],
        },

        {
          fieldName: "tipologiaUsoNonDomestica",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
          ],
        },
        {
          fieldName: "numeroResidenti",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
            {
              if: "tipologiaUsoDomestica",
              is: AreaClassification.RESIDENT_DOMESTIC_USE,
            },
          ],
        },

        {
          fieldName: "numeroCondominialeUnita",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
            {
              if: "tipologiaUsoDomestica",
              is: AreaClassification.CONDOMINIUM_USE,
            },
          ],
        },
        {
          fieldName: "numeroCondominialeResidenti",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
            {
              if: "tipologiaUsoDomestica",
              is: AreaClassification.CONDOMINIUM_USE,
            },
          ],
        },
        {
          fieldName: "numeroCondominialeUnitaAltri",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
            {
              if: "tipologiaUsoDomestica",
              is: AreaClassification.CONDOMINIUM_USE,
            },
          ],
        },
        {
          fieldName: "case_2",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
          ],
        },
        {
          fieldName: "case_2_1",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "ISTITUTI_SCOLASTICI",
            },
          ],
        },
        {
          fieldName: "case_2_2",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA",
            },
          ],
        },
        {
          fieldName: "case_2_3",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "CASE_DI_CURA_E_DI_ASSISTENZA",
            },
          ],
        },
        {
          fieldName: "case_2_4",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "OSPEDALI_E_STRUTTURE_OSPEDALIERE",
            },
          ],
        },
        {
          fieldName: "case_3",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "PRESE_ANTINCENDIO",
            },
          ],
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey="cases.prese.digitalization" />} />,
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "case_3",
              is: "PRESA_ANTINCENDIO_CON_CONTATORE",
            },
          ],
        },
        {
          fieldName: "case_3_1",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.PUBLIC,
            },
            {
              if: "case_2",
              is: "ALTRO",
            },
          ],
        },
        {
          fieldName: "case_5",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
            },
          ],
        },
        {
          fieldName: "case_6",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
            },
          ],
        },
        {
          fieldName: "case_7",
          grid: {
            xs: 6,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.INDUSTRIAL_USE,
            },
          ],
        },
        {
          fieldName: "case_4",
          grid: {
            xs: 7,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.OTHER,
            },
          ],
        },
        {
          fieldName: "case_4_1",
          grid: {
            xs: 5,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.OTHER,
            },
            {
              if: "case_4",
              is: "USO_DIVERSO",
            },
          ],
        },
        {
          fieldName: "case_4_2",
          grid: {
            xs: 5,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.OTHER,
            },
            {
              if: "case_4",
              is: "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
            },
          ],
        },
        {
          fieldName: "case_4_3",
          grid: {
            xs: 5,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
            {
              if: "tipologiaUsoNonDomestica",
              is: AreaClassification.OTHER,
            },
            {
              if: "case_4",
              is: "USO_IRRIGUO_E_COLLETTIVO",
            },
          ],
        },
        {
          fieldName: "tipologiaDiAttivita",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.NON_DOMESTICO,
            },
          ],
          className: "tipologiaDiAttivita",
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.tipologia_uso" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "tipologiaUso",
              is: TipologiaUsoFornitura.DOMESTICO,
            },
          ],
        },
        {
          fieldName: "tipologiaIntestatario",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: 'tipologiaUsoNonDomestica',
              is: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE
            }],
          className: "px-5 px-md-4"
        },
        {
          fieldName: 'tipologiaIntestatario',
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: 'tipologiaUsoNonDomestica',
              is: AreaClassification.ARTISAN_AND_COMMERCIAL_USE
            }],

          className: "px-5 px-md-4",
        },
      ],
    },
    // step 5.2
    {
      chapter: false,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step5_2.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.allacciamento.step5_2.title" />,
      fields: [
        {
          fieldName: null,
          text: (
            <div className="declaration">
              <p>
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_1" />
              </p>
              <p>
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_2" />
              </p>
              <p>
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_3" />
              </p>
            </div>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "estremiDelDocumento1",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: 'signValue',
              is: false,
            },
          ],

        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: 'signValue',
              is: false,
            },
          ],

        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.title" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="conditions">
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.description" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },
    // step 6
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step6_1.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.allacciamento.step6_1.title" />,
      fields: [
        {
          fieldName: "bollettaOnlineAttiva",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="checkbox-sub-text">
              <TranslatedText i18nKey="cases.voltura.layout.bolleta_online.sub_text" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },
    // step 7
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.allacciamento.step7_1.title" />,

      fields: [
        {
          fieldName: "bollettaAddebitoBancario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="checkbox-sub-text">
              <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.sub_text" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cognomeNomeDelConto",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleTitolare",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },

        {
          fieldName: "indirizzoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cellulareDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "telefonoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },

        {
          fieldName: "iban",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "bankName",
          grid: {
            xs: 12,
            md: 8,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "agencia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
      ],
    },
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step8_1.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.allacciamento.step8_1.title" />,
      fields: [
        {
          fieldName: null,
          text: (
            <div className="information-privacy">
              <p>
                <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
              </p>
            </div>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },

    // step 9
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.digitalization.title" />,
      title: <TranslatedText i18nKey="cases.digitalization.title" />,
      fields: [
        {
          fieldName: "estremiDelDocumento",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: signValue,
              is: false,
            }
          ],

        },
        {
          fieldName: "idType",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "IdType",
              is: ""
            }
          ]
        },
        {
          fieldName: "ID",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence"
          }

        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return (_values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence") &&
              (_values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER);
          }

        },
        {
          fieldName: "Legittima",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER;
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleDoc",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "verbale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            }]
        },
        {
          fieldName: "CCIAA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "case_2",
              is: "PRESE_ANTINCENDIO",
            },
          ],
        },
        {
          fieldName: "dichiarazione",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "case_2",
              is: "PRESE_ANTINCENDIO",
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
        {
          fieldName: "Fattura",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
      ],
    },
  ])
}

// Contiene dettagli sul case form
const getFormDetails = (digitalization) => {
  const pdfLink = getCorrectLink(casesInfoAllacciamento);
  return {
    title: <TranslatedText i18nKey={"cases.allacciamento.title"} />,
    description: digitalization ? (<TranslatedText i18nKey="cases.allacciamento.help" />) : (
      <a
        className="link-a"
        href={pdfLink}
        target={"_blank"}
        rel="noopener noreferrer"
      >
        <span
          className="gc-icon-functional-doc-pdf-2-col"
          style={{ verticalAlign: "bottom" }}
        >
          <span className="path1" />
          <span className="path2" />
        </span>{" "}
        {<TranslatedText i18nKey="cases.allacciamento.description.info" />}
      </a>
    ),
    stepper: CaseStepperType.Full,
    helpText: digitalization ? null : (
      <>
        <TranslatedText i18nKey={"cases.allacciamento.help"} />
        <>
          {sign ? (
            <TranslatedText i18nKey="cases.voltura.help_text_1_digitalization" />
          ) : (
            <TranslatedText i18nKey="cases.voltura.help_text_1" />
          )}
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href={`mailto:contratti@gruppocap.it`}
          >
            contratti@gruppocap.it
          </a>{" "}
          <br />
          <TranslatedText i18nKey="cases.voltura.help_text_2" />
        </>

      </>
    ),
    successText: (
      <>
        <p>
          <TranslatedText i18nKey="cases.voltura.success_text_1" />{" "}
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href={`mailto:contratti@gruppocap.it`}
          >
            contratti@gruppocap.it
          </a>{" "}
          <TranslatedText i18nKey="cases.voltura.success_text_3" />
        </p>
      </>
    ),
    incompleteActivation: true,
    summary: true,
    autoOpenHelpModal: !digitalization,
  };
};

const punctualizationMapping = (payload) => {
  const EXISTING =
    payload[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE;
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const DOMESTIC = payload[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO;
  let usagetypeareraClassification;
  let subtypeArera;
  if (payload[case_2.name] === 'PRESE_ANTINCENDIO') {
    usagetypeareraClassification = payload[case_3.name]
  } else if (payload[case_2.name] === 'ALTRO') {
    usagetypeareraClassification = payload[case_3_1.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE) {
    usagetypeareraClassification = payload[case_5.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.ARTISAN_AND_COMMERCIAL_USE) {
    usagetypeareraClassification = payload[case_6.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.INDUSTRIAL_USE) {
    usagetypeareraClassification = payload[case_7.name]
  } else if (payload[case_4.name] === 'USO_DIVERSO') {
    usagetypeareraClassification = payload[case_4_1.name]
  } else if (payload[case_4.name] === 'USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE') {
    usagetypeareraClassification = payload[case_4_2.name]
  } else if (payload[case_4.name] === 'USO_IRRIGUO_E_COLLETTIVO') {
    usagetypeareraClassification = payload[case_4_3.name]
  } else if (payload[case_2.name] === 'ISTITUTI_SCOLASTICI') {
    usagetypeareraClassification = payload[case_2_1.name]
  } else if (payload[case_2.name] === 'PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA') {
    usagetypeareraClassification = payload[case_2_2.name]
  } else if (payload[case_2.name] === 'CASE_DI_CURA_E_DI_ASSISTENZA') {
    usagetypeareraClassification = payload[case_2_3.name]
  } else if (payload[case_2.name] === 'OSPEDALI_E_STRUTTURE_OSPEDALIERE') {
    usagetypeareraClassification = payload[case_2_4.name]
  }

  if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC) {
    subtypeArera = "PUBLIC_USE_DISALIMENTABILE"
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.OTHER) {
    subtypeArera = payload[case_4.name]
  }

  const {
    sdiCode,
    pec,
    paCode,
    cigCode,
    cupCode,
    splitPaymentCat,
    businessName,
  } = payload;
  return {
    toSign: false,

    accountHolder: {
      personType: payload[tipoIntestatario.name],
      holderType: payload[inQualitaDi.name],
      ...(payload[inQualitaDi.name] === AccountHolderType.OTHER && {
        holderOther: payload[inQualitaDi_altro.name],
      }),
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaNome.name],
      surname: NATURAL
        ? payload[fisicaCognome.name]
        : payload[giuridicaCognome.name],
      ...(!NATURAL && { businessName }),
      fiscalCode: NATURAL
        ? payload[fisicaCodiceFiscale.name]
        : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && { birthPlace: payload[fisicaNatoA.name] }),
      ...(NATURAL && {
        birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy"),
      }),
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      address: {
        city: NATURAL
          ? payload[fisicaComuneResidenza.name]
          : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL
          ? payload[fisicaCAP.name]
          : payload[giuridicaCAP.name],
        province: NATURAL
          ? payload[fisicaProvincia.name]
          : payload[giuridicaProvincia.name],
        street: NATURAL
          ? payload[fisicaIndirizzo.name].split(",")[0] || ""
          : payload[giuridicaIndirizzo.name].split(",")[0] || "",
        streetNumber: NATURAL
          ? payload[fisicaIndirizzo.name].split(",")[1] || ""
          : payload[giuridicaIndirizzo.name].split(",")[1] || "",
      },
      billing: {
        sdiCode,
        pec,
        paCode,
        cigCode,
        cupCode,
        splitPaymentCat,
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      contactsInfo: {
        addressRecapito: {
          city: EXISTING
            ? payload[bollettaEsistenteComune.name]
            : payload[bollettaNuovoComune.name],
          postalCode: EXISTING
            ? payload[bollettaEsistenteCap.name]
            : payload[bollettaNuovoCap.name],
          province: EXISTING
            ? payload[bollettaEsistenteProvincia.name]
            : payload[bollettaNuovoProvincia.name],
          street: EXISTING
            ? payload[bollettaEsistenteIndirizzo.name].split(",")[0] || ""
            : payload[bollettaNuovoIndirizzo.name].split(",")[0] || "",
          streetNumber: EXISTING
            ? payload[bollettaEsistenteIndirizzo.name].split(",")[1] || ""
            : payload[bollettaNuovoIndirizzo.name].split(",")[1] || "",
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
        },
        email: EXISTING
          ? payload[bollettaEsistenteEmail.name]
          : payload[bollettaNuovoEmail.name],
        ...(EXISTING
          ? payload[bollettaEsistenteFisso.name] && {
            landlinePhoneNumber: payload[bollettaEsistenteFisso.name],
          }
          : payload[bollettaNuovoFisso.name] && {
            landlinePhoneNumber: payload[bollettaNuovoFisso.name],
          }),
        mobilePhoneNumber: EXISTING
          ? payload[bollettaEsistenteCellulare.name]
          : payload[bollettaNuovoCellulare.name],
        pec: EXISTING
          ? payload[bollettaEsistentePec.name]
          : payload[bollettaNuovoPec.name],
      },
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      owner: payload[cognomeNomeDelConto.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      bankName: payload[bankName.name],
      address: payload[indirizzoDomiciliazione.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      bankBranch: payload[agencia.name],
      iban: payload[iban.name],
    },
    cadastre: {
      administrativeUnit: payload[datiCatastali_comune.name],
      administrativeUnitProvince: payload[datiCatastali_provincia.name],
      building: payload[datiCatastali_edificio.name],
      cadastralLot: payload[datiCatastali_particella.name],
      cadastralMunicipality: payload[datiCatastali_comuneCatastale.name],
      cadastralMunicipalityCode:
        payload[datiCatastali_codiceComuneCatastale.name],
      cadastralMunicipalityProvince:
        payload[datiCatastali_provinciaComuneCatastale.name],
      flat: payload[datiCatastali_appartamento.name],
      floor: payload[datiCatastali_piano.name],
      plot: payload[datiCatastali_foglio.name],
      staircase: payload[datiCatastali_scale.name],
      street: payload[datiCatastali_indirizzo.name],
      streetNumber: payload[datiCatastali_civico.name],
      subDivision: payload[datiCatastali_subalterno.name],
      type: payload[datiCatastali_tipologia.name],
      urbanSection: payload[datiCatastali_sezioneUrbana.name],
    },
    newContract: {
      domesticUseType: payload[tipologiaUso.name],
      ...(DOMESTIC && {
        areraClassification: payload[tipologiaUsoDomestica.name],
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.RESIDENT_DOMESTIC_USE && {
        residentNumber: Number(payload[numeroResidenti.name]),
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        residentialUnits: Number(payload[numeroCondominialeUnita.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        housingUnits: Number(payload[numeroCondominialeResidenti.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        notResidentialUnits: Number(
          payload[numeroCondominialeUnitaAltri.name]
        ),
      }),

      ...(!DOMESTIC && { areraClassification: (payload[case_2.name] === 'ALTRO' && payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC ? 'PUBLIC_USE_DISALIMENTABILE' : payload[case_2.name] !== 'ALTRO' && payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC ? 'PUBLIC_USE_NOT_DISALIMENTABILE' : payload[tipologiaUsoNonDomestica.name]) }),

      subtypeAreraClassification:
        subtypeArera,
      ...(((DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE) ||
        !DOMESTIC) && {
        usagetypeareraClassification: usagetypeareraClassification,
      }),

      identityCardCode: payload[estremiDelDocumento1.name],
      building: {
        nameSurname: payload[datiImmobile_cognomeNomeRecapito.name],
        fiscalCode: payload[datiImmobile_codiceFiscale.name],
        vatNumber: payload[datiImmobile_partitaIva.name],
        address: payload[datiImmobile_indirizzoCivico.name],
        city: payload[datiImmobile_comune.name],
        postalCode: payload[datiImmobile_cap.name],
        province: payload[datiImmobile_provincia.name],
        mobilePhoneNumber: payload[datiImmobile_cellulare.name],
        ...(payload[datiImmobile_fisso.name] && {
          landlinePhoneNumber: payload[datiImmobile_fisso.name],
        }),
        email: payload[datiImmobile_email.name],
      },
      puf: {
        city: payload[comune.name],
        street: payload[via.name],
        streetNumber: payload[numeroCivico.name],
      },
      onlineBill: {
        enabled: payload[bollettaOnlineAttiva.name],
      },
      ...(payload[inQualitaDi.name] === AccountHolderType.OWNER && {
        declaration: {
          undersigned: `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]
            }`,
          acts: [
            {
              type: DeclarationType.OWNER,
              enabled: payload[dichiaro_diEssereIntestatario.name],
              number: payload[dichiaro_diEssereIntestatario_numero.name],
              date: moment(
                payload[dichiaro_diEssereIntestatario_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              enabled: payload[dichiaro_possessoImmobile.name],
              type: DeclarationType.POSSESSION,
              from: moment(payload[dichiaro_possessoImmobile_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.BUILDING,
              enabled: payload[dichiaro_rilasciatoPermesso.name],
              number: payload[dichiaro_rilasciatoPermesso_numero.name],
              date: moment(
                payload[dichiaro_rilasciatoPermesso_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              type: DeclarationType.DIA,
              enabled: payload[dichiaro_presentataDia.name],
              number: payload[dichiaro_presentataDia_numero.name],
              date: moment(payload[dichiaro_presentataDia_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.SCIA,
              enabled: payload[dichiaro_presentataScia.name],
              number: payload[dichiaro_presentataScia_numero.name],
              date: moment(payload[dichiaro_presentataScia_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.HOUSE_AGE,
              enabled: payload[dichiaro_dataCostruzioneIdonea.name],
              date: moment(
                payload[dichiaro_dataCostruzioneIdonea_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              type: DeclarationType.OUTLET_DIVISION,
              enabled: payload[dichiaro_presaEsistente.name],
              number: payload[dichiaro_presaEsistente_numero.name],
              date: moment(payload[dichiaro_presaEsistente_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.OTHER,
              enabled: payload[dichiaro_altro.name],
              note: payload[dichiaro_altro_testo.name],
            },
          ],
        },
      }),
      owner: payload[tipologiaIntestatario.name]
        ? payload[tipologiaIntestatario.name]
        : null,
    },
    addressList : [
      NATURAL ? model.formField.fisicaIndirizzo.egonCodeResponse :  model.formField.giuridicaIndirizzo.egonCodeResponse,
      EXISTING ?  model.formField.bollettaEsistenteIndirizzo.egonCodeResponse :  model.formField.bollettaNuovoIndirizzo.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
      model.formField.via.egonCodeProprietario,
      model.formField.via.egonCodePuf,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: CaseForms.Allaccio,
    subType: payload[tipologia.name],
  };
};
const translatedMapping = (payload, excludeProperties) => {
  const EXISTING =
    payload[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE;
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const DOMESTIC =
    payload[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO;
  const {
    sdiCode,
    pec,
    paCode,
    cigCode,
    cupCode,
    splitPaymentCat,
    businessName,
  } = payload;
  if (excludeProperties) {
    return punctualizationMapping(payload);
  }
  let subtypeArera;
  let usagetypeareraClassification;
  if (payload[tipologiaUsoDomestica.name] === AreaClassification.CONDOMINIUM_USE) {
    // usagetypeareraClassification = payload[case_1.name]
  } else if (payload[case_2.name] === 'PRESE_ANTINCENDIO') {
    usagetypeareraClassification = payload[case_3.name]
  } else if (payload[case_2.name] === 'ALTRO') {
    usagetypeareraClassification = payload[case_3_1.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE) {
    usagetypeareraClassification = payload[case_5.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.ARTISAN_AND_COMMERCIAL_USE) {
    usagetypeareraClassification = payload[case_6.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.INDUSTRIAL_USE) {
    usagetypeareraClassification = payload[case_7.name]
  } else if (payload[case_4.name] === 'USO_DIVERSO') {
    usagetypeareraClassification = payload[case_4_1.name]
  } else if (payload[case_4.name] === 'USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE') {
    usagetypeareraClassification = payload[case_4_2.name]
  } else if (payload[case_4.name] === 'USO_IRRIGUO_E_COLLETTIVO') {
    usagetypeareraClassification = payload[case_4_3.name]
  } else if (payload[case_2.name] === 'ISTITUTI_SCOLASTICI') {
    usagetypeareraClassification = payload[case_2_1.name]
  } else if (payload[case_2.name] === 'PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA') {
    usagetypeareraClassification = payload[case_2_2.name]
  } else if (payload[case_2.name] === 'CASE_DI_CURA_E_DI_ASSISTENZA') {
    usagetypeareraClassification = payload[case_2_3.name]
  } else if (payload[case_2.name] === 'OSPEDALI_E_STRUTTURE_OSPEDALIERE') {
    usagetypeareraClassification = payload[case_2_4.name]
  }


  if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC) {
    subtypeArera = payload[case_2.name]
  } else if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.OTHER) {
    subtypeArera = payload[case_4.name]
  }
  return {
    toSign: true,
    attachments: [
      payload[inQualitaDi.name] !== AccountHolderType.OWNER
        ? {
          data: payload[Legittima.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[codiceFiscaleDoc.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[verbale.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.LEGAL_REPRESENTATIVE
        ? {
          data: payload[CCIAA.name],
        }
        : null,
      payload[case_2.name] === "PRESE_ANTINCENDIO"
        ? {
          data: payload[dichiarazione.name],
        }
        : null,
      {
        data: payload[ID.name],
      },
    ],
    accountHolder: {
      personType: payload[tipoIntestatario.name],
      holderType: payload[inQualitaDi.name],
      ...(payload[inQualitaDi.name] === AccountHolderType.OTHER && {
        holderOther: payload[inQualitaDi_altro.name],
      }),
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaNome.name],
      surname: NATURAL
        ? payload[fisicaCognome.name]
        : payload[giuridicaCognome.name],
      ...(!NATURAL && { businessName }),
      fiscalCode: NATURAL
        ? payload[fisicaCodiceFiscale.name]
        : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && { birthPlace: payload[fisicaNatoA.name] }),
      ...(NATURAL && {
        birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy"),
      }),
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      address: {
        city: NATURAL
          ? payload[fisicaComuneResidenza.name]
          : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL
          ? payload[fisicaCAP.name]
          : payload[giuridicaCAP.name],
        province: NATURAL
          ? payload[fisicaProvincia.name]
          : payload[giuridicaProvincia.name],
        street: NATURAL
          ? payload[fisicaIndirizzo.name].split(",")[0] || ""
          : payload[giuridicaIndirizzo.name].split(",")[0] || "",
        streetNumber: NATURAL
          ? payload[fisicaIndirizzo.name].split(",")[1] || ""
          : payload[giuridicaIndirizzo.name].split(",")[1] || "",
      },
      billing: {
        sdiCode,
        pec,
        paCode,
        cigCode,
        cupCode,
        splitPaymentCat,
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      contactsInfo: {
        addressRecapito: {
          city: EXISTING
            ? payload[bollettaEsistenteComune.name]
            : payload[bollettaNuovoComune.name],
          postalCode: EXISTING
            ? payload[bollettaEsistenteCap.name]
            : payload[bollettaNuovoCap.name],
          province: EXISTING
            ? payload[bollettaEsistenteProvincia.name]
            : payload[bollettaNuovoProvincia.name],
          street: EXISTING
            ? payload[bollettaEsistenteIndirizzo.name].split(",")[0] || ""
            : payload[bollettaNuovoIndirizzo.name].split(",")[0] || "",
          streetNumber: EXISTING
            ? payload[bollettaEsistenteIndirizzo.name].split(",")[1] || ""
            : payload[bollettaNuovoIndirizzo.name].split(",")[1] || "",
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
        },
        email: EXISTING
          ? payload[bollettaEsistenteEmail.name]
          : payload[bollettaNuovoEmail.name],
        ...(EXISTING
          ? payload[bollettaEsistenteFisso.name] && {
            landlinePhoneNumber: payload[bollettaEsistenteFisso.name],
          }
          : payload[bollettaNuovoFisso.name] && {
            landlinePhoneNumber: payload[bollettaNuovoFisso.name],
          }),
        mobilePhoneNumber: EXISTING
          ? payload[bollettaEsistenteCellulare.name]
          : payload[bollettaNuovoCellulare.name],
        pec: EXISTING
          ? payload[bollettaEsistentePec.name]
          : payload[bollettaNuovoPec.name],
      },
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      owner: payload[cognomeNomeDelConto.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      bankName: payload[bankName.name],
      address: payload[indirizzoDomiciliazione.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      bankBranch: payload[agencia.name],
      iban: payload[iban.name],
    },
    cadastre: {
      administrativeUnit: payload[datiCatastali_comune.name],
      administrativeUnitProvince: payload[datiCatastali_provincia.name],
      building: payload[datiCatastali_edificio.name],
      cadastralLot: payload[datiCatastali_particella.name],
      cadastralMunicipality: payload[datiCatastali_comuneCatastale.name],
      cadastralMunicipalityCode:
        payload[datiCatastali_codiceComuneCatastale.name],
      cadastralMunicipalityProvince:
        payload[datiCatastali_provinciaComuneCatastale.name],
      flat: payload[datiCatastali_appartamento.name],
      floor: payload[datiCatastali_piano.name],
      plot: payload[datiCatastali_foglio.name],
      staircase: payload[datiCatastali_scale.name],
      street: payload[datiCatastali_indirizzo.name],
      streetNumber: payload[datiCatastali_civico.name],
      subDivision: payload[datiCatastali_subalterno.name],
      type: payload[datiCatastali_tipologia.name],
      urbanSection: payload[datiCatastali_sezioneUrbana.name],
    },
    newContract: {
      ...(DOMESTIC && {
        areraClassification: payload[tipologiaUsoDomestica.name],
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.RESIDENT_DOMESTIC_USE && {
        residentNumber: Number(payload[numeroResidenti.name]),
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        residentialUnits: Number(payload[numeroCondominialeUnita.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        housingUnits: Number(payload[numeroCondominialeResidenti.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        notResidentialUnits: Number(
          payload[numeroCondominialeUnitaAltri.name]
        ),
      }),

      ...(!DOMESTIC && { areraClassification: (payload[case_2.name] === 'ALTRO' && payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC ? 'PUBLIC_USE_DISALIMENTABILE' : payload[case_2.name] !== 'ALTRO' && payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC ? 'PUBLIC_USE_NOT_DISALIMENTABILE' : payload[tipologiaUsoNonDomestica.name]) }),


      subtypeAreraClassification:
        subtypeArera,
      ...(((DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE) ||
        !DOMESTIC) && {
        usagetypeAreraClassification: usagetypeareraClassification,
      }),

      identityCardCode: payload[estremiDelDocumento.name],
      building: {
        nameSurname: payload[datiImmobile_cognomeNomeRecapito.name],
        fiscalCode: payload[datiImmobile_codiceFiscale.name],
        vatNumber: payload[datiImmobile_partitaIva.name],
        address: payload[datiImmobile_indirizzoCivico.name],
        city: payload[datiImmobile_comune.name],
        postalCode: payload[datiImmobile_cap.name],
        province: payload[datiImmobile_provincia.name],
        mobilePhoneNumber: payload[datiImmobile_cellulare.name],
        ...(payload[datiImmobile_fisso.name] && {
          landlinePhoneNumber: payload[datiImmobile_fisso.name],
        }),
        email: payload[datiImmobile_email.name],
      },
      puf: {
        city: payload[comune.name],
        street: payload[via.name],
        streetNumber: payload[numeroCivico.name],
      },
      onlineBill: {
        enabled: payload[bollettaOnlineAttiva.name],
      },
      ...(payload[inQualitaDi.name] === AccountHolderType.OWNER && {
        declaration: {
          undersigned: `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]
            }`,
          acts: [
            {
              type: DeclarationType.OWNER,
              enabled: payload[dichiaro_diEssereIntestatario.name],
              number: payload[dichiaro_diEssereIntestatario_numero.name],
              date: moment(
                payload[dichiaro_diEssereIntestatario_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              enabled: payload[dichiaro_possessoImmobile.name],
              type: DeclarationType.POSSESSION,
              from: moment(payload[dichiaro_possessoImmobile_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.BUILDING,
              enabled: payload[dichiaro_rilasciatoPermesso.name],
              number: payload[dichiaro_rilasciatoPermesso_numero.name],
              date: moment(
                payload[dichiaro_rilasciatoPermesso_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              type: DeclarationType.DIA,
              enabled: payload[dichiaro_presentataDia.name],
              number: payload[dichiaro_presentataDia_numero.name],
              date: moment(payload[dichiaro_presentataDia_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.SCIA,
              enabled: payload[dichiaro_presentataScia.name],
              number: payload[dichiaro_presentataScia_numero.name],
              date: moment(payload[dichiaro_presentataScia_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.HOUSE_AGE,
              enabled: payload[dichiaro_dataCostruzioneIdonea.name],
              date: moment(
                payload[dichiaro_dataCostruzioneIdonea_data.name]
              ).format("DD/MM/yyyy"),
            },
            {
              type: DeclarationType.OUTLET_DIVISION,
              enabled: payload[dichiaro_presaEsistente.name],
              number: payload[dichiaro_presaEsistente_numero.name],
              date: moment(payload[dichiaro_presaEsistente_data.name]).format(
                "DD/MM/yyyy"
              ),
            },
            {
              type: DeclarationType.OTHER,
              enabled: payload[dichiaro_altro.name],
              note: payload[dichiaro_altro_testo.name],
            },
          ],
        },
      }),
      owner: payload[tipologiaIntestatario.name]
        ? payload[tipologiaIntestatario.name]
        : null,
    },
    addressList : [
      NATURAL ? model.formField.fisicaIndirizzo.egonCodeResponse :  model.formField.giuridicaIndirizzo.egonCodeResponse,
      EXISTING ?  model.formField.bollettaEsistenteIndirizzo.egonCodeResponse :  model.formField.bollettaNuovoIndirizzo.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
      model.formField.via.egonCodeProprietario,
      model.formField.via.egonCodePuf,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: CaseForms.Allaccio,
    subType: payload[tipologia.name],
  };
};

const translatedInverseMapping = (payload, values, excludeProperties) => {
  let mapping = {};
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });
  if (excludeProperties) {
    mapping = {
      "req.accountHolder.businessName": businessName.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderOther": inQualitaDi_altro.name,
      "req.accountHolder.holderType": inQualitaDi.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaIndirizzo.name
          : giuridicaIndirizzo.name,
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaIndirizzo.name
          : giuridicaIndirizzo.name,

      "req.accountHolder.billing.sdiCode": sdiCode.name,
      "req.accountHolder.billing.pec": pec.name,
      "req.accountHolder.billing.paCode": paCode.name,
      "req.accountHolder.billing.cigCode": cigCode.name,
      "req.accountHolder.billing.cupCode": cupCode.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteComune.name
          : bollettaNuovoComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteCap.name
          : bollettaNuovoCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteProvincia.name
          : bollettaNuovoProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteIndirizzo.name
          : bollettaNuovoIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteIndirizzo.name
          : bollettaNuovoIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,

      "req.accountHolder.contactsInfo.email":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteEmail.name
          : bollettaNuovoEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteFisso.name
          : bollettaNuovoFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteCellulare.name
          : bollettaNuovoCellulare.name,
      "req.accountHolder.contactsInfo.pec":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistentePec.name
          : bollettaNuovoPec.name,

      "req.currentContract.declaration.address.city":
        fisicaComuneResidenza.name,
      "req.currentContract.declaration.address.province": fisicaProvincia.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.iban": iban.name,

      "req.cadastre.administrativeUnit": datiCatastali_comune.name,
      "req.cadastre.administrativeUnitProvince": datiCatastali_provincia.name,
      "req.cadastre.building": datiCatastali_edificio.name,
      "req.cadastre.cadastralLot": datiCatastali_particella.name,
      "req.cadastre.cadastralMunicipality": datiCatastali_comuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastali_codiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastali_provinciaComuneCatastale.name,
      "req.cadastre.flat": datiCatastali_appartamento.name,
      "req.cadastre.floor": datiCatastali_piano.name,
      "req.cadastre.plot": datiCatastali_foglio.name,
      "req.cadastre.staircase": datiCatastali_scale.name,
      "req.cadastre.street": datiCatastali_indirizzo.name,
      "req.cadastre.streetNumber": datiCatastali_civico.name,
      "req.cadastre.subDivision": datiCatastali_subalterno.name,
      "req.cadastre.type": datiCatastali_tipologia.name,
      "req.cadastre.urbanSection": datiCatastali_sezioneUrbana.name,

      "req.newContract.domesticUseType": tipologiaUso.name,
      "req.newContract.AreaClassification": tipologiaUsoDomestica.name,
      "req.newContract.residentNumber": numeroResidenti.name,
      "req.newContract.residentialUnits": numeroCondominialeUnita.name,
      "req.newContract.housingUnits": numeroCondominialeResidenti.name,
      "req.newContract.notResidentialUnits": numeroCondominialeUnitaAltri.name,
      "req.newContract.identityCardCode": estremiDelDocumento.name,
      "req.newContract.owner": tipologiaIntestatario.name,

      "req.newContract.building.nameSurname":
        datiImmobile_cognomeNomeRecapito.name,
      "req.newContract.building.fiscalCode": datiImmobile_codiceFiscale.name,
      "req.newContract.building.vatNumber": datiImmobile_partitaIva.name,
      "req.newContract.building.address": datiImmobile_indirizzoCivico.name,
      "req.newContract.building.city": datiImmobile_comune.name,
      "req.newContract.building.postalCode": datiImmobile_cap.name,
      "req.newContract.building.province": datiImmobile_provincia.name,
      "req.newContract.building.mobilePhoneNumber": datiImmobile_cellulare.name,
      "req.newContract.building.landlinePhoneNumber": datiImmobile_fisso.name,
      "req.newContract.building.email": datiImmobile_email.name,

      "req.newContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.newContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.newContract.puf.city": comune.name,
      "req.newContract.puf.street": via.name,
      "req.newContract.puf.streetNumber": numeroCivico.name,

      "req.newContract.declaration.acts": [
        {
          from: dichiaro_possessoImmobile_data.name,
        },
      ],

      // TODO : confirm mapping for array
      "req.oldContract.declaration.acts": [
        {
          enabled: dichiaro_diEssereIntestatario.name,
          number: dichiaro_diEssereIntestatario_numero.name,
          date: dichiaro_diEssereIntestatario_data.name,
        },
        {
          enabled: dichiaro_rilasciatoPermesso.name,
          number: dichiaro_rilasciatoPermesso_numero.name,
          date: dichiaro_rilasciatoPermesso_data.name,
        },
        {
          enabled: dichiaro_presentataDia.name,
          number: dichiaro_presentataDia_numero.name,
          date: dichiaro_presentataDia_data.name,
        },
        {
          enabled: dichiaro_presentataScia.name,
          number: dichiaro_presentataScia_numero.name,
          date: dichiaro_presentataScia_data.name,
        },
        {
          enabled: dichiaro_dataCostruzioneIdonea.name,
          date: dichiaro_dataCostruzioneIdonea_data.name,
        },
        {
          enabled: dichiaro_presaEsistente.name,
          number: dichiaro_presaEsistente_numero.name,
          date: dichiaro_presaEsistente_data.name,
        },
        {
          enabled: dichiaro_altro.name,
          note: dichiaro_altro_testo.name,
        },
      ],

      "req.oldContract.subtypeAreraClassification": case_2.name,
      // "req.oldContract.usagetypeareraClassification": case_1.name,

      "req.subType": tipologia.name,
    };
  } else {
    mapping = {
      "req.accountHolder.businessName": businessName.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderOther": inQualitaDi_altro.name,
      "req.accountHolder.holderType": inQualitaDi.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaIndirizzo.name
          : giuridicaIndirizzo.name,
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaIndirizzo.name
          : giuridicaIndirizzo.name,

      "req.accountHolder.billing.sdiCode": sdiCode.name,
      "req.accountHolder.billing.pec": pec.name,
      "req.accountHolder.billing.paCode": paCode.name,
      "req.accountHolder.billing.cigCode": cigCode.name,
      "req.accountHolder.billing.cupCode": cupCode.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteComune.name
          : bollettaNuovoComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteCap.name
          : bollettaNuovoCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteProvincia.name
          : bollettaNuovoProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteIndirizzo.name
          : bollettaNuovoIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteIndirizzo.name
          : bollettaNuovoIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,

      "req.accountHolder.contactsInfo.email":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteEmail.name
          : bollettaNuovoEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteFisso.name
          : bollettaNuovoFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistenteCellulare.name
          : bollettaNuovoCellulare.name,
      "req.accountHolder.contactsInfo.pec":
        values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE
          ? bollettaEsistentePec.name
          : bollettaNuovoPec.name,

      "req.currentContract.declaration.address.city":
        fisicaComuneResidenza.name,
      "req.currentContract.declaration.address.province": fisicaProvincia.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.iban": iban.name,

      "req.cadastre.administrativeUnit": datiCatastali_comune.name,
      "req.cadastre.administrativeUnitProvince": datiCatastali_provincia.name,
      "req.cadastre.building": datiCatastali_edificio.name,
      "req.cadastre.cadastralLot": datiCatastali_particella.name,
      "req.cadastre.cadastralMunicipality": datiCatastali_comuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastali_codiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastali_provinciaComuneCatastale.name,
      "req.cadastre.flat": datiCatastali_appartamento.name,
      "req.cadastre.floor": datiCatastali_piano.name,
      "req.cadastre.plot": datiCatastali_foglio.name,
      "req.cadastre.staircase": datiCatastali_scale.name,
      "req.cadastre.street": datiCatastali_indirizzo.name,
      "req.cadastre.streetNumber": datiCatastali_civico.name,
      "req.cadastre.subDivision": datiCatastali_subalterno.name,
      "req.cadastre.type": datiCatastali_tipologia.name,
      "req.cadastre.urbanSection": datiCatastali_sezioneUrbana.name,

      "req.newContract.domesticUseType": tipologiaUso.name,
      "req.newContract.AreaClassification": tipologiaUsoDomestica.name,
      "req.newContract.residentNumber": numeroResidenti.name,
      "req.newContract.residentialUnits": numeroCondominialeUnita.name,
      "req.newContract.housingUnits": numeroCondominialeResidenti.name,
      "req.newContract.notResidentialUnits": numeroCondominialeUnitaAltri.name,
      "req.newContract.identityCardCode": estremiDelDocumento.name,
      "req.newContract.owner": tipologiaIntestatario.name,

      "req.newContract.building.nameSurname":
        datiImmobile_cognomeNomeRecapito.name,
      "req.newContract.building.fiscalCode": datiImmobile_codiceFiscale.name,
      "req.newContract.building.vatNumber": datiImmobile_partitaIva.name,
      "req.newContract.building.address": datiImmobile_indirizzoCivico.name,
      "req.newContract.building.city": datiImmobile_comune.name,
      "req.newContract.building.postalCode": datiImmobile_cap.name,
      "req.newContract.building.province": datiImmobile_provincia.name,
      "req.newContract.building.mobilePhoneNumber": datiImmobile_cellulare.name,
      "req.newContract.building.landlinePhoneNumber": datiImmobile_fisso.name,
      "req.newContract.building.email": datiImmobile_email.name,

      "req.newContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.newContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.newContract.puf.city": comune.name,
      "req.newContract.puf.street": via.name,
      "req.newContract.puf.streetNumber": numeroCivico.name,

      "req.newContract.declaration.acts": [
        {
          from: dichiaro_possessoImmobile_data.name,
        },
      ],

      // TODO : confirm mapping for array
      "req.oldContract.declaration.acts": [
        {
          enabled: dichiaro_diEssereIntestatario.name,
          number: dichiaro_diEssereIntestatario_numero.name,
          date: dichiaro_diEssereIntestatario_data.name,
        },
        {
          enabled: dichiaro_rilasciatoPermesso.name,
          number: dichiaro_rilasciatoPermesso_numero.name,
          date: dichiaro_rilasciatoPermesso_data.name,
        },
        {
          enabled: dichiaro_presentataDia.name,
          number: dichiaro_presentataDia_numero.name,
          date: dichiaro_presentataDia_data.name,
        },
        {
          enabled: dichiaro_presentataScia.name,
          number: dichiaro_presentataScia_numero.name,
          date: dichiaro_presentataScia_data.name,
        },
        {
          enabled: dichiaro_dataCostruzioneIdonea.name,
          date: dichiaro_dataCostruzioneIdonea_data.name,
        },
        {
          enabled: dichiaro_presaEsistente.name,
          number: dichiaro_presaEsistente_numero.name,
          date: dichiaro_presaEsistente_data.name,
        },
        {
          enabled: dichiaro_altro.name,
          note: dichiaro_altro_testo.name,
        },
      ],

      "req.newContract.subtypeAreraClassification": case_2.name,
      // "req.oldContract.usagetypeareraClassification": case_1.name,

      "req.subType": tipologia.name,
    };
  }

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const mutation = {
  type: CaseMutationType.Complex,
};
const getTrackingEventKo = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Allaccio, "step": "invio_richiesta", "esito": "KO" }) };
const getTrackingEvent = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Allaccio, "step": "invio_richiesta", "esito": "OK" }) };
const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  const layout = getLayout(privacyLink, privacyCtaLabel);
  sign = signDigital
  let validation = GetValidationSchema();
  if (excludeSteps && counter < 1) {
    const stepsExcluded = excludeSteps;
    let deletedLayout = removeRequiredStep(stepsExcluded, layout);
    const { formField } = model;
    validation = removeDeletedLayoutFields(
      deletedLayout,
      formField,
      initialValues,
      validation
    );
    model = { ...model, formField };
  }
  return {
    model,
    validationSchema: validation,
    initialValues,
    layout,
    formDetails: getFormDetails(sign),
    trackingEventKo: getTrackingEventKo(),
    trackingEvent: getTrackingEvent(),
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};

export default main;
